// Design collection pages core runtime. Extracted from
// snippets/bg-designs-collection.liquid (PERF-08): the inline script hit
// Shopify's 256KB liquid cap and re-downloaded with every page view; as an
// asset it is CDN-cached. Page inputs arrive via
// window.BGDesignsCollectionConfig (brandSlug, masterPricingUrl), written
// inline by the snippet before this file loads with defer.
document.addEventListener('DOMContentLoaded', () => {

  const fallbackProductImage = (() => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 320"><rect width="480" height="320" fill="#f8fafc"/><rect x="32" y="24" width="416" height="272" rx="14" fill="#ffffff" stroke="#d4d9e2" stroke-width="8" stroke-dasharray="14 12"/><rect x="72" y="64" width="336" height="192" rx="10" fill="#f3f4f6"/><path d="M160 128h160M160 168h160M160 208h104" stroke="#c7ceda" stroke-width="10" stroke-linecap="round"/></svg>`;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  })();

  const searchBarContainer = document.querySelector('.search-bar-container');
  if (searchBarContainer) {
    searchBarContainer.dataset.searchEnabled = include_search_bar ? 'true' : 'false';
  }

  /* =======================
     1) FETCH & PREPROCESS
     ======================= */
  const allFilterFields = [
    { field: 'product', id: 'product-filter' },
    { field: 'category', id: 'category-filter' },
    { field: 'industry', id: 'industry-filter' },
    { field: 'shape', id: 'shape-filter' },
    { field: 'size', id: 'size-filter' },
    { field: 'direct_mail', id: 'direct_mail-filter' },
    { field: 'occasion', id: 'occasion-filter' },
    { field: 'use_case', id: 'use_case-filter' },
    { field: 'printed_sides', id: 'printed_sides-filter' },
    { field: 'fold', id: 'fold-filter' },
    { field: 'type', id: 'type-filter' },
    { field: 'print_colors', id: 'print_colors-filter' },
    { field: 'equipment', id: 'equipment-filter' },
    { field: 'material', id: 'material-filter' },
    { field: 'editability', id: 'editability-filter' },
    { field: 'orientation', id: 'orientation-filter' },
    { field: 'color', id: 'color-filter' },
    { field: 'corners', id: 'corners-filter' },
    { field: 'style', id: 'style-filter' },
    { field: 'perforation', id: 'perforation-filter' },
    { field: 'styles_themes', id: 'styles_themes-filter' }
  ];

  const filtersToHideSet = new Set(filtersToHide);
  const filterFields = allFilterFields.filter(f => !filtersToHideSet.has(f.field));
  const SEARCH_EXTRA_FIELDS = ['template_name', 'tags', 'designnum'];
  const SEARCH_FIELDS = Array.from(new Set(allFilterFields.map(f => f.field).concat(SEARCH_EXTRA_FIELDS)));
  const SEARCH_SUGGESTION_FIELDS = Array.from(new Set(filterFields.map(f => f.field).concat(['template_name', 'tags'])));
  const SEARCH_DEBOUNCE_MS = 250;

  let allDesignsRaw = [];
  let designByNumber = {};
	  const templateCollectionDesignsUrl = '/apps/qps-commerce-control-plane/designer/template-collection-designs?storeKey=' + encodeURIComponent((window.BGDesignsCollectionConfig && window.BGDesignsCollectionConfig.brandSlug) || 'wcrmarketing') + '&pagePath=' + encodeURIComponent(window.location.pathname);
	  let templatePageProductCatalog = {};
	  let templatePageProductData = {};

  function getDesignKey(d) {
    return String(
      d && (
        d.designnum
        || d.templateLookup
        || d.templatePublicId
        || d.publicId
        || d.id
      ) || ''
    ).trim();
  }

  // We'll store references to placeholders for each product
  let startFromScratchByProduct = {};
  let uploadDesignByProduct = {};

  // For pagination, search, etc.
  let currentPage = 1;
  window.currentPage = currentPage;
  const itemsPerPage = 21;

  // Elements
  const suggestionsContainer = document.getElementById('search-suggestions');
  const filtersSidebar = document.getElementById('filters-sidebar');
  const openFiltersBtnMobile = document.querySelector('.open-filters-btn-mobile');
  const closeFiltersBtnMobile = document.getElementById('close-filters-btn-mobile');
  const showResultsBtn = document.getElementById('show-results-btn');
  const searchInput = document.getElementById('search-input');
  const searchButton = document.querySelector('.search__button');
  const clearSearchButton = document.querySelector('.clear-search');
  const sortSelect = document.getElementById('sort-select');

  // LIGHTBOX
  const lightboxOverlay = document.getElementById('lightbox-overlay');
  const lightboxImage   = document.getElementById('lightbox-image');
  const lightboxClose   = document.getElementById('lightbox-close');
  
  let __suppressURLSync = true;

  const DISCOUNT_TAGS = [
    'discount50','discount45','discount40','discount35','discount30',
    'discount25','discount20','discount15','discount10','discount5'
  ];

  const MEMBER_DISCOUNT = (() => {
    if (window.ultimatePlan) return { bonus: 0, label: 'Ultimate Member' };
    if (window.proPlan) return { bonus: 0, label: 'Pro Member' };
    return { bonus: 0, label: '' };
  })();

  function extractBaseDiscountFromTags(handle) {
    if (!handle) return 0;

    const mapDiscount = window.productDiscounts && window.productDiscounts[handle];
    const parsedMapDiscount = parseInt(mapDiscount, 10);
    if (!Number.isNaN(parsedMapDiscount) && parsedMapDiscount > 0) {
      return Math.min(100, parsedMapDiscount);
    }

    const tagsString = (window.productTags && window.productTags[handle]) || '';
    if (!tagsString) return 0;
    const tagArray = tagsString.split(',').map(t => t.trim().toLowerCase());
    for (const tag of DISCOUNT_TAGS) {
      if (tagArray.includes(tag)) {
        return parseInt(tag.replace('discount',''), 10);
      }
    }
    return 0;
  }

  function hasUnbeatablePriceTag(handle) {
    if (!handle) return false;
    const tagsString = (window.productTags && window.productTags[handle]) || '';
    if (!tagsString) return false;
    return tagsString.split(',').some(tag => tag.trim().toLowerCase() === 'unbeatable-price');
  }

	  function normalizeTemplateCollectionDesignsPayload(payload) {
	    if (!payload || typeof payload !== 'object') return null;
	    return payload.result && typeof payload.result === 'object' ? payload.result : payload;
	  }

	  function normalizeProductHandleValue(value) {
	    return String(value || '').trim().toLowerCase();
	  }

  function dropRetiredTemplatePageFields(record) {
    const next = record && typeof record === 'object' ? { ...record } : {};
    ['product' + 'TemplatesURL', 'product' + '_templates_url'].forEach(key => {
      if (Object.prototype.hasOwnProperty.call(next, key)) delete next[key];
    });
    return next;
  }

	  function readTemplateCollectionList(value) {
	    if (Array.isArray(value)) {
	      return Array.from(new Set(value.map(entry => String(entry || '').trim().toLowerCase()).filter(Boolean)));
	    }
	    const text = String(value || '').trim();
	    if (!text) return [];
	    return Array.from(new Set(text.split(/[,|\n]/g).map(entry => entry.trim().toLowerCase()).filter(Boolean)));
	  }

	  function applyTemplateCollectionTargetProductsToProductData(productData, targetProducts) {
	    const sourceProducts = productData && productData.products && typeof productData.products === 'object'
	      ? productData.products
	      : {};
	    const products = { ...sourceProducts };
	    const rows = Array.isArray(targetProducts) ? targetProducts : [];
	    rows.forEach(targetProduct => {
	      if (!targetProduct || typeof targetProduct !== 'object') return;
	      const handle = normalizeProductHandleValue(targetProduct.handle);
	      if (!handle) return;
	      const existing = products[handle] && typeof products[handle] === 'object'
	        ? dropRetiredTemplatePageFields(products[handle])
	        : {};
	      const targetProductFields = dropRetiredTemplatePageFields(targetProduct);
	      const nextMapping = targetProduct.editorMapping && typeof targetProduct.editorMapping === 'object'
	        ? targetProduct.editorMapping
	        : {};
	      const merged = {
	        ...existing,
	        ...targetProductFields,
	        handle,
	        productName: String(targetProduct.productName || targetProduct.title || existing.productName || handle).trim(),
	        editorMapping: {
	          ...nextMapping,
	          templateCollectionPath: window.location.pathname
	        },
	        templateSourceHandle: String(nextMapping.templateSourceHandle || targetProduct.templateSourceHandle || '').trim(),
	        returnProductHandle: String(nextMapping.returnProductHandle || targetProduct.returnProductHandle || handle).trim()
	      };
	      products[handle] = merged;
	    });
	    return {
	      ...(productData && typeof productData === 'object' ? productData : {}),
	      products
	    };
	  }

	  function applyMembershipDiscount(basePercent) {
    if (!basePercent || basePercent <= 0) {
      return { percent: basePercent || 0, label: '', hasBonus: false };
    }
    const bonus = MEMBER_DISCOUNT.bonus;
    if (bonus > 0) {
      const adjusted = Math.min(100, basePercent + bonus);
      return { percent: adjusted, label: MEMBER_DISCOUNT.label, hasBonus: true };
    }
    return { percent: basePercent, label: '', hasBonus: false };
  }

  function buildDiscountBadgeText(percent, options = {}) {
    if (options.unbeatablePrice) return 'Unbeatable Price';
    if (!percent || percent <= 0) return '';
    const memberLabel = options.memberLabel || '';
    if (memberLabel) {
      return `${percent}% Off ${memberLabel}`;
    }
    if (options.includeSaleSuffix) {
      return `${percent}% Off Sale`;
    }
    return `${percent}% Off`;
  }
	
	
	// === Size display ordering (by visible label, case-insensitive) ===
// Any size whose visible label starts with one of these keys
// will be sorted by this order; others fall back to your existing sort.
const SIZE_LABEL_PRIORITY = {
  'standard': 0,
  'credit card': 1
};

	
  function openLightbox(imageSrc) {
    lightboxImage.src = imageSrc;
    lightboxOverlay.style.display = 'flex';
  }
  function closeLightbox() {
    lightboxOverlay.style.display = 'none';
    lightboxImage.src = '';
  }
  lightboxClose.addEventListener('click', closeLightbox);
  lightboxOverlay.addEventListener('click', (e) => {
    if (e.target === lightboxOverlay) {
      closeLightbox();
    }
  });
  
  function makeImagesClickableForLightbox() {
    const desktopImgs = document.querySelectorAll('.modal-images-desktop img');
    const mobileImgs  = document.querySelectorAll('.mobile-images-container img');
    const allImgs = [...desktopImgs, ...mobileImgs];
    allImgs.forEach(img => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => {
        openLightbox(img.src);
      });
    });
  }

const EXCLUDED_PRODUCT_HANDLES = new Set([
  'social-media-ad-designer',
  'wcr-ad-setups',
]);

	
	

function normalizedTemplateCollectionTargetHandle(d) {
  const values = [
    d && d.__foundationTargetProductHandle,
    d && d.__foundationReturnProductHandle,
    d && d.__foundationTargetTemplateSourceHandle,
    d && d.__foundationTemplateSourceHandle,
    d && d.product_handle,
    d && d.productHandle,
    d && d.handle
  ];
  for (const value of values) {
    const handle = String(value || '').toLowerCase().trim();
    if (handle) return handle;
  }
  return '';
}

function shouldExcludeDesign(d) {
  const handle = normalizedTemplateCollectionTargetHandle(d);
  if (!handle) return false;
  if (EXCLUDED_PRODUCT_HANDLES.has(handle)) return true;
  if (bgIsTestingProductHandle(handle)) return true;
  if (bgHiddenProductHandles.has(handle)) return true;
  return false;
}

/* ===== Product visibility + default product images ===== */

// Dedicated QA pages (e.g. /pages/yard-sign-testing-templates) intentionally target
// testing products, so the testing exclusion only applies on non-testing page paths.
const bgPageAllowsTestingProducts = window.location.pathname.toLowerCase().includes('testing');
const BG_TESTING_PRODUCT_HANDLE_PATTERN = /(^|[-_])(test|testing|debug)([-_]|$)/;
const bgHiddenProductHandles = new Set();
const bgProductImageByHandle = {};
let bgProductInfoPromise = null;
let bgRebuildSearchSuggestionIndex = null;

function bgIsTestingProductHandle(handle) {
  if (bgPageAllowsTestingProducts) return false;
  const normalized = String(handle || '').toLowerCase().trim();
  if (!normalized) return false;
  return BG_TESTING_PRODUCT_HANDLE_PATTERN.test(normalized);
}

function bgIsVisibleTemplatePageProduct(product) {
  const handle = String(product && product.handle || '').toLowerCase().trim();
  if (!handle) return false;
  if (EXCLUDED_PRODUCT_HANDLES.has(handle)) return false;
  if (bgIsTestingProductHandle(handle)) return false;
  if (bgHiddenProductHandles.has(handle)) return false;
  return true;
}

// Shopify UNLISTED products still serve /products/<handle>.js with 200, so the
// 404 probe below cannot exclude them. The control-plane status lane reports
// active/unlisted per handle from the Shopify Admin catalog; only the exact
// 'unlisted' verdict hides a product. Missing entries, unknown statuses, and
// any transport/parse failure change nothing (fail-open: probe-only behavior).
function bgApplyProductStorefrontStatuses(handles) {
  if (!handles.length) return Promise.resolve();
  const query = 'storeKey=' + encodeURIComponent((window.BGDesignsCollectionConfig && window.BGDesignsCollectionConfig.brandSlug) || 'wcrmarketing')
    + '&handles=' + encodeURIComponent(handles.slice().sort().join(','));
  return fetch('/apps/qps-commerce-control-plane/designer/template-collection-product-status?' + query)
    .then(r => (r.ok ? r.json() : null))
    .then(payload => {
      const statusByHandle = payload && payload.ok === true
        && payload.statusByHandle && typeof payload.statusByHandle === 'object'
        ? payload.statusByHandle
        : null;
      if (!statusByHandle) return;
      Object.keys(statusByHandle).forEach(rawHandle => {
        const handle = String(rawHandle || '').toLowerCase().trim();
        if (!handle) return;
        if (String(statusByHandle[rawHandle] || '').toLowerCase().trim() !== 'unlisted') return;
        // The dedicated QA pages target *-testing products that stay UNLISTED
        // in Shopify on purpose; the testing-page guard applies to the status
        // lane exactly like the handle-pattern exclusion above.
        if (bgPageAllowsTestingProducts && BG_TESTING_PRODUCT_HANDLE_PATTERN.test(handle)) return;
        bgHiddenProductHandles.add(handle);
      });
    })
    .catch(() => {});
}

// /products/<handle>.js is the storefront's own product JSON: it 404s for products
// not published to the online store and carries the product's default image.
function bgLoadProductStorefrontInfo() {
  if (bgProductInfoPromise) return bgProductInfoPromise;
  const records = Object.values(getProductCatalogMap()).filter(p => p && p.handle);
  const recordHandles = records
    .map(product => String(product.handle || '').toLowerCase().trim())
    .filter(Boolean);
  bgProductInfoPromise = Promise.all([
    bgApplyProductStorefrontStatuses(recordHandles),
  ].concat(records.map(product => {
    const handle = String(product.handle || '').toLowerCase().trim();
    if (!handle) return Promise.resolve();
    return fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then(r => {
        if (r.status === 404) {
          bgHiddenProductHandles.add(handle);
          return null;
        }
        if (!r.ok) return null;
        return r.json();
      })
      .then(info => {
        if (!info) return;
        const image = String(
          info.featured_image
          || (Array.isArray(info.images) && info.images.length ? info.images[0] : '')
          || ''
        ).trim();
        if (image) bgProductImageByHandle[handle] = image;
      })
      .catch(() => {});
  })));
  return bgProductInfoPromise;
}

function bgShopifyImageWidth(url, widthPx) {
  const raw = String(url || '').trim();
  if (!raw || raw.startsWith('data:')) return raw;
  try {
    const parsed = new URL(raw, window.location.origin);
    parsed.searchParams.set('width', String(widthPx));
    return parsed.toString();
  } catch (e) {
    return raw;
  }
}

function bgFindExampleDesignForProduct(product) {
  const designs = Array.isArray(window.allDesignsUngrouped) ? window.allDesignsUngrouped : [];
  const productName = getProductName(product).toLowerCase();
  const handle = String(product && product.handle || '').toLowerCase().trim();
  for (const d of designs) {
    const templateName = (d && d['template_name'] || '').trim().toLowerCase();
    if (templateName === 'start from scratch' || templateName === 'upload completed design') continue;
    const designName = String(d && d.product || '').trim().toLowerCase();
    if (productName && designName === productName) return d;
    if (handle && normalizedTemplateCollectionTargetHandle(d) === handle) return d;
  }
  return null;
}

function bgResolveProductImageUrl(product, exampleDesign, widthPx) {
  const handle = String(product && product.handle || '').toLowerCase().trim();
  const featured = handle ? bgProductImageByHandle[handle] : '';
  if (featured) return bgShopifyImageWidth(featured, widthPx);
  const d = exampleDesign || bgFindExampleDesignForProduct(product);
  const preview = d
    ? String(
      d.design_preview_url
      || (Array.isArray(d.previews) && d.previews.length ? d.previews[0] : '')
      || ''
    ).trim()
    : '';
  if (preview) return preview;
  return fallbackProductImage;
}

// Late-arriving product images (probe finishes after render) upgrade in place.
function bgUpdateProductImageElements() {
  document.querySelectorAll('img[data-bg-product-image]').forEach(img => {
    const handle = String(img.getAttribute('data-bg-product-image') || '').toLowerCase().trim();
    const featured = handle ? bgProductImageByHandle[handle] : '';
    if (!featured) return;
    const widthPx = Number(img.getAttribute('data-bg-product-image-width')) || 360;
    const next = bgShopifyImageWidth(featured, widthPx);
    if (next && img.src !== next) img.src = next;
  });
}

/* ===== Product swatch row (replaces the sidebar product filter) ===== */

let bgSelectedSwatchHandle = '';

function bgGetSelectedSwatchProduct() {
  return bgSelectedSwatchHandle ? getProductByHandle(bgSelectedSwatchHandle) : null;
}

function bgDesignMatchesProduct(d, product) {
  if (!d || !product) return false;
  const productHandle = String(product.handle || '').toLowerCase().trim();
  const designHandle = normalizedTemplateCollectionTargetHandle(d);
  if (productHandle && designHandle === productHandle) return true;
  const designName = String(d.product || '').trim().toLowerCase();
  const productName = getProductName(product).toLowerCase();
  return !!designName && !!productName && designName === productName;
}

function bgDesignMatchesSelectedSwatch(d) {
  if (!bgSelectedSwatchHandle) return true;
  const product = bgGetSelectedSwatchProduct();
  if (!product) return true;
  return bgDesignMatchesProduct(d, product);
}

function bgSyncSwatchRowSelection() {
  document.querySelectorAll('.bg-product-swatch').forEach(btn => {
    const isSelected = String(btn.getAttribute('data-handle') || '') === bgSelectedSwatchHandle;
    btn.classList.toggle('is-selected', isSelected);
    btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  });
}

function bgSetSwatchSelection(handle) {
  const normalized = String(handle || '').toLowerCase().trim();
  bgSelectedSwatchHandle = (normalized && normalized === bgSelectedSwatchHandle) ? '' : normalized;
  bgSyncSwatchRowSelection();
  filterDesigns();
}

function bgClearSwatchSelection() {
  bgSelectedSwatchHandle = '';
  bgSyncSwatchRowSelection();
}

function bgApplySwatchSelectionFromValues(values) {
  // Only honor a URL product selection when the swatch row can render it,
  // otherwise the grid would filter with no visible control to clear it.
  if (filtersToHideSet.has('product')) return;
  const records = getTemplatePageProductRecords();
  if (records.length < 2) return;
  const wanted = (values || []).map(v => String(v || '').trim().toLowerCase()).filter(Boolean);
  if (!wanted.length) return;
  let match = null;
  for (const value of wanted) {
    match = records.find(product => {
      const name = getProductName(product).toLowerCase();
      const handle = String(product.handle || '').toLowerCase().trim();
      return name === value || handle === value;
    });
    if (match) break;
  }
  if (!match) return;
  bgSelectedSwatchHandle = String(match.handle || '').toLowerCase().trim();
  bgSyncSwatchRowSelection();
}

function bgUpdateProductSwatchNavigation() {
  const shell = document.querySelector('[data-bg-product-swatch-shell]');
  if (!shell || shell.hidden) return;
  const row = shell.querySelector('[data-bg-product-swatches]');
  const previous = shell.querySelector('[data-bg-product-swatches-previous]');
  const next = shell.querySelector('[data-bg-product-swatches-next]');
  if (!row || !previous || !next) return;
  const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
  // Browsers can settle a padded scroller a few pixels in from either edge.
  const edgeTolerance = 16;
  const atStart = row.scrollLeft <= edgeTolerance;
  const atEnd = row.scrollLeft >= maxScroll - edgeTolerance;
  previous.disabled = atStart;
  next.disabled = atEnd;
  shell.classList.toggle('is-at-start', atStart);
  shell.classList.toggle('is-at-end', atEnd);
}

function bgBindProductSwatchNavigation() {
  const shell = document.querySelector('[data-bg-product-swatch-shell]');
  if (!shell || shell.dataset.bgNavigationBound === 'true') return;
  const row = shell.querySelector('[data-bg-product-swatches]');
  const previous = shell.querySelector('[data-bg-product-swatches-previous]');
  const next = shell.querySelector('[data-bg-product-swatches-next]');
  if (!row || !previous || !next) return;
  shell.dataset.bgNavigationBound = 'true';
  const scrollProducts = direction => {
    const distance = Math.max(240, Math.floor(row.clientWidth * 0.72));
    row.scrollBy({ left: distance * direction, behavior: 'smooth' });
  };
  previous.addEventListener('click', () => scrollProducts(-1));
  next.addEventListener('click', () => scrollProducts(1));
  row.addEventListener('scroll', bgUpdateProductSwatchNavigation, { passive: true });
  window.addEventListener('resize', bgUpdateProductSwatchNavigation);
}

function bgGetEligibleTemplatePageProducts(designs) {
  const candidates = Array.isArray(designs) ? designs : [];
  return getTemplatePageProductRecords().filter(product =>
    candidates.some(design => bgDesignMatchesProduct(design, product))
  );
}

function renderProductSwatchRow(eligibleDesigns) {
  const hosts = Array.from(document.querySelectorAll('[data-bg-product-swatches]'));
  const roots = Array.from(document.querySelectorAll('[data-bg-product-filter-root]'));
  if (!hosts.length) return;
  if (filtersToHideSet.has('product')) {
    bgSelectedSwatchHandle = '';
    roots.forEach(root => { root.hidden = true; });
    return;
  }
  const records = bgGetEligibleTemplatePageProducts(eligibleDesigns);
  if (bgSelectedSwatchHandle && !records.some(p => String(p.handle || '').toLowerCase().trim() === bgSelectedSwatchHandle)) {
    bgSelectedSwatchHandle = '';
  }
  if (records.length < 2) {
    bgSelectedSwatchHandle = '';
    roots.forEach(root => { root.hidden = true; });
    hosts.forEach(host => { host.innerHTML = ''; });
    return;
  }

  const makeSwatch = (handle, label, imageUrl) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bg-product-swatch' + (handle ? '' : ' bg-product-swatch--all');
    btn.setAttribute('data-handle', handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.title = label;
    if (imageUrl) {
      const thumb = document.createElement('span');
      thumb.className = 'bg-product-swatch__thumb';
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.setAttribute('data-bg-product-image', handle);
      img.setAttribute('data-bg-product-image-width', '120');
      thumb.appendChild(img);
      btn.appendChild(thumb);
    }
    const text = document.createElement('span');
    text.className = 'bg-product-swatch__label';
    text.textContent = label;
    btn.appendChild(text);
    btn.addEventListener('click', () => bgSetSwatchSelection(handle));
    return btn;
  };

  hosts.forEach(host => {
    host.innerHTML = '';
    host.appendChild(makeSwatch('', 'All products', ''));
    records.forEach(product => {
      const handle = String(product.handle || '').toLowerCase().trim();
      const label = getProductName(product);
      if (!label) return;
      host.appendChild(makeSwatch(handle, label, bgResolveProductImageUrl(product, null, 120)));
    });
  });

  roots.forEach(root => { root.hidden = false; });
  bgSyncSwatchRowSelection();
  bgBindProductSwatchNavigation();
  window.requestAnimationFrame(bgUpdateProductSwatchNavigation);
}
	
	
function applyInitialSortFromMeta() {
  // 1) URL override
  const params   = new URLSearchParams(window.location.search);
  const override = (params.get('sort') || '').toLowerCase(); // popular | new | random | default

  // 2) Metafield -> safe string
  let meta = 'default';
  const ds = window.defaultSort;
  if (typeof ds === 'string' && ds.trim()) {
    meta = ds.trim();
  } else if (ds && typeof ds.value === 'string' && ds.value.trim()) {
    // In case the metafield was serialized as an object like { value: "popular" }
    meta = ds.value.trim();
  }
  meta = meta.toLowerCase();

  // 3) Choose source (URL wins)
  const source = override || meta;

  // 4) Map to <select> values your renderer understands
  const mapToSelect = {
    default: 'default',
    popular: 'most_popular',
    most_popular: 'most_popular', // allow direct value too
    new: 'newest',
    newest: 'newest',             // allow direct value too
    random: 'random'
  };
  const targetSelectValue = mapToSelect[source] || 'default';

  // 5) Set the <select>
  const selectEl = document.getElementById('sort-select') || window.sortSelect;
  if (selectEl) selectEl.value = targetSelectValue;

  // 6) Sync the top buttons’ active state
  const mapToButton = {
    random:       '#sort-btn-random',
    most_popular: '#sort-btn-popular',
    newest:       '#sort-btn-new'
  };
  document.querySelectorAll('#sort-buttons .sort-button').forEach(b => b.classList.remove('active'));
  const btn = document.querySelector(mapToButton[targetSelectValue]);
  if (btn) btn.classList.add('active');

  // (Optional) Debug the raw metafield if you’re still seeing surprises:
  // console.debug('defaultSort raw ->', ds, 'resolved ->', targetSelectValue);
}


	
	
	
  /* =======================
   1) FETCH & PREPROCESS
   ======================= */
	

window.MasterPricingData = {};
const legacyReferencePricingPromise = fetch((window.BGDesignsCollectionConfig && window.BGDesignsCollectionConfig.masterPricingUrl) || '/cdn/shop/t/assets/bg-master-pricing-data.json')
  .then(response => response.json())
  .then(data => {
    window.MasterPricingData = data; 
    // console.log("Master Pricing Data loaded:", data);
  })
  .catch(err => {
    console.error("Error loading Master Pricing JSON:", err);
  });
	
	
	
	// PERF-08 paged designs lane: the first page paints immediately and the
	// remaining pages stream in behind it (each page is a distinct edge-cache
	// entry on the worker). A worker that ignores limit/offset returns the
	// full corpus with no hasMore envelope, so page 0 is then the whole
	// dataset and no merge pass runs.
	const BG_DESIGNS_PAGE_LIMIT = 250;
	const BG_DESIGNS_PAGE_CONCURRENCY = 4;

	function bgFetchDesignsPage(offset) {
	  return fetch(templateCollectionDesignsUrl + '&limit=' + BG_DESIGNS_PAGE_LIMIT + '&offset=' + offset)
	    .then(r => r.json())
	    .catch(() => null);
	}

	function bgApplyTemplateCollectionDesigns(resolvedTemplateCollectionDesigns, isRefresh) {
	    const data = resolvedTemplateCollectionDesigns && Array.isArray(resolvedTemplateCollectionDesigns.items)
	      ? resolvedTemplateCollectionDesigns.items
	      : [];
	    if (!Array.isArray(data)) {
	      throw new Error("template collection designs payload is not an array");
	    }
	    const targetProducts = resolvedTemplateCollectionDesigns && Array.isArray(resolvedTemplateCollectionDesigns.targetProducts)
	      ? resolvedTemplateCollectionDesigns.targetProducts
	      : [];
	    // targetProducts ride complete on every page, so the refresh pass keeps
	    // the page-0 resolution untouched.
	    if (!isRefresh) {
	      templatePageProductData = applyTemplateCollectionTargetProductsToProductData({}, targetProducts);
    templatePageProductCatalog = templatePageProductData && templatePageProductData.products && typeof templatePageProductData.products === 'object'
      ? templatePageProductData.products
      : {};
	    }

let ungroupedData = data.filter(d => {
  const name = (d['template_name'] || '').trim();
  if (!name || name === '+') return false;
  if (shouldExcludeDesign(d)) return false;
  return true;
});

    // 1B) Build a lookup by stable design key, references to placeholders, etc.
    // Rebuilt from scratch so the streamed-merge refresh replaces, never leaks.
    designByNumber = {};
    ungroupedData.forEach(d => {
      const designKey = getDesignKey(d);
      if (designKey) {
        designByNumber[designKey] = d;
      }
    });


	window.designSuiteIndex = {};
	ungroupedData.forEach(d => {
	  const suite = (d.design_suite ?? '').toString().trim();
	  if (!suite) return;
	  if (!window.designSuiteIndex[suite]) window.designSuiteIndex[suite] = [];
	  const designKey = getDesignKey(d);
	  if (designKey) window.designSuiteIndex[suite].push(designKey);
	});
	// de-dupe just in case
	Object.keys(window.designSuiteIndex).forEach(k => {
	  window.designSuiteIndex[k] = Array.from(new Set(window.designSuiteIndex[k]));
	});


    // Initialize shared modal engine (BGDesignModal) with the same dataset, if available.
    // initFromAllTemplates is a full replace with no listener registration, so
    // the refresh pass may safely re-call it with the merged corpus.
    window.BGDesignModalBootstrapData = ungroupedData;
    if (window.BGDesignModal && typeof window.BGDesignModal.initFromAllTemplates === 'function') {
      window.BGDesignModal.initFromAllTemplates(ungroupedData);
    }

    // Possibly store placeholders in startFromScratchByProduct / uploadDesignByProduct
    startFromScratchByProduct = {};
    uploadDesignByProduct = {};
    ungroupedData.forEach(d => {
      const tName = (d['template_name'] || '').trim().toLowerCase();
      const p     = (d.product || '').trim();
      if (!p) return;
      if (tName === 'start from scratch') {
        if (!startFromScratchByProduct[p]) {
          startFromScratchByProduct[p] = [];
        }
        startFromScratchByProduct[p].push(getDesignKey(d));
      } else if (tName === 'upload completed design') {
        if (!uploadDesignByProduct[p]) {
          uploadDesignByProduct[p] = [];
        }
        uploadDesignByProduct[p].push(getDesignKey(d));
      }
    });

    // 1C) Group designs if needed
    let groupedData = groupDesignsIfNeeded([...ungroupedData]);

    // 1D) Store them globally
    window.allDesignsUngrouped = ungroupedData;
    window.allDesignsGrouped   = groupedData;

	window.filterSourceData = ungroupedData;

	let finalData =
      (window.groupDesigns === 'true')
        ? groupedData
        : ungroupedData;

    window.allDesigns = finalData;

	    if (isRefresh) {
	      // Streamed-merge refresh: same in-place recipe as the hidden-product
	      // pass below — rebuild the suggestion index (never re-call
	      // initializeSearchSuggestions: it would stack a duplicate input
	      // listener), refresh product info for products introduced by later
	      // pages, and re-filter without URL rewrite, toolbar scroll, or a
	      // pagination reset mid-browse. filterDesigns() re-derives filter
	      // options from the merged corpus while preserving checked state.
	      if (typeof bgRebuildSearchSuggestionIndex === 'function') {
	        bgRebuildSearchSuggestionIndex();
	      }
	      bgLoadProductStorefrontInfo().then(() => {
	        bgUpdateProductImageElements();
	        renderProductSwatchRow(getFilteredDesigns({ ignoreProductSwatch: true }));
	        if (currentPage === 1) {
	          const wasSuppressed = __suppressURLSync;
	          __suppressURLSync = true;
	          isFirstFilter = true;
	          filterDesigns();
	          __suppressURLSync = wasSuppressed;
	        }
	      });
	      return;
	    }

    // 1E) Continue as before: Search suggestions, filters, initial render
    initializeSearchSuggestions();
    populateFilters();

    // Build initial results
	applyInitialSortFromMeta();

    const filtered = getFilteredDesigns();
    const pages    = Math.ceil(filtered.length / itemsPerPage);
    updatePaginationControls(pages);
    renderHeroCtaBar(filtered);
    renderDesigns(filtered);
    renderProductSwatchRow(getFilteredDesigns({ ignoreProductSwatch: true }));
    updateSelectedFilters();
    updateResultsCount();
    applyFiltersFromURL();

    // Resolve storefront product info (default images + published state) and
    // refresh the affected UI once it lands. Image upgrades happen in place;
    // the full pipeline re-runs only when an unpublished product was found,
    // and then without the user-visible side effects of a filter action
    // (no URL rewrite, no toolbar scroll, no pagination reset mid-browse).
    bgLoadProductStorefrontInfo().then(() => {
      bgUpdateProductImageElements();
      if (!bgHiddenProductHandles.size) return;
      renderProductSwatchRow(getFilteredDesigns({ ignoreProductSwatch: true }));
      if (typeof bgRebuildSearchSuggestionIndex === 'function') {
        bgRebuildSearchSuggestionIndex();
      }
      if (currentPage === 1) {
        const wasSuppressed = __suppressURLSync;
        __suppressURLSync = true;
        isFirstFilter = true;
        filterDesigns();
        __suppressURLSync = wasSuppressed;
      }
    });
	}

	bgFetchDesignsPage(0)
	  .then(firstPagePayload => {
	    const firstPage = normalizeTemplateCollectionDesignsPayload(firstPagePayload);
	    if (!firstPage || !Array.isArray(firstPage.items)) {
	      throw new Error("template collection designs payload is not an array");
	    }
	    // First paint from page 0.
	    bgApplyTemplateCollectionDesigns(firstPage, false);

	    const total = Number(firstPage.total);
	    if (firstPage.hasMore !== true || !Number.isFinite(total) || total <= firstPage.items.length) {
	      return; // complete payload (or a worker that ignored pagination)
	    }
	    const offsets = [];
	    for (let offset = firstPage.items.length; offset < total; offset += BG_DESIGNS_PAGE_LIMIT) {
	      offsets.push(offset);
	    }
	    const pagesByOffset = new Map();
	    let cursor = 0;
	    const fetchNext = () => {
	      if (cursor >= offsets.length) return Promise.resolve();
	      const offset = offsets[cursor];
	      cursor += 1;
	      return bgFetchDesignsPage(offset).then(payload => {
	        const resolved = normalizeTemplateCollectionDesignsPayload(payload);
	        if (!resolved || !Array.isArray(resolved.items)) {
	          throw new Error('paged designs fetch failed at offset ' + offset);
	        }
	        pagesByOffset.set(offset, resolved.items);
	        return fetchNext();
	      });
	    };
	    const lanes = [];
	    for (let lane = 0; lane < Math.min(BG_DESIGNS_PAGE_CONCURRENCY, offsets.length); lane += 1) {
	      lanes.push(fetchNext());
	    }
	    return Promise.all(lanes)
	      .then(() => {
	        const merged = firstPage.items.slice();
	        const seenKeys = new Set(merged.map(getDesignKey).filter(Boolean));
	        offsets.forEach(offset => {
	          (pagesByOffset.get(offset) || []).forEach(item => {
	            const key = getDesignKey(item);
	            if (key && seenKeys.has(key)) return; // page straddled a revision change
	            if (key) seenKeys.add(key);
	            merged.push(item);
	          });
	        });
	        bgApplyTemplateCollectionDesigns({ items: merged, targetProducts: firstPage.targetProducts }, true);
	      })
	      .catch(() => {
	        // A later page failed: fall back to one unpaged full fetch so the
	        // corpus still completes; page-0 UI keeps working if that fails too.
	        return fetch(templateCollectionDesignsUrl).then(r => r.json()).catch(() => null).then(fullPayload => {
	          const resolvedFull = normalizeTemplateCollectionDesignsPayload(fullPayload);
	          if (resolvedFull && Array.isArray(resolvedFull.items) && resolvedFull.items.length > firstPage.items.length) {
	            bgApplyTemplateCollectionDesigns(resolvedFull, true);
	          }
	        });
	      });
  })
  .catch(err => console.error("Error fetching JSON:", err));

  // Mobile filter toggles
  openFiltersBtnMobile.addEventListener('click', () => filtersSidebar.classList.add('open'));
  closeFiltersBtnMobile.addEventListener('click', () => filtersSidebar.classList.remove('open'));
  showResultsBtn.addEventListener('click', () => filtersSidebar.classList.remove('open'));

  // Search triggers
  const debouncedSearch = debounce(() => {
    if (!window.allDesigns) return;
    filterDesigns();
  }, SEARCH_DEBOUNCE_MS);

  searchInput.addEventListener('keydown', handleSearchKeydown);
  searchButton.addEventListener('click', () => {
    hideSearchSuggestions();
    filterDesigns();
  });
  searchInput.addEventListener('input', () => {
    const hasQuery = !!searchInput.value.trim();
    clearSearchButton.style.display = hasQuery ? 'block' : 'none';
    if (!hasQuery) hideSearchSuggestions();
    debouncedSearch();
  });
  searchInput.addEventListener('blur', () => {
    setTimeout(() => {
      hideSearchSuggestions();
    }, 150);
  });
  clearSearchButton.addEventListener('click', clearSearch);
  document.addEventListener('click', (e) => {
    if (searchBarContainer && !searchBarContainer.contains(e.target)) {
      hideSearchSuggestions();
    }
  });

  // Sorting
  sortSelect.addEventListener('change', () => {
    currentPage = 1;
    window.currentPage = currentPage;
    const filteredDesigns = getFilteredDesigns();
    const numberOfPages = Math.ceil(filteredDesigns.length / itemsPerPage);
    updatePaginationControls(numberOfPages);
    renderHeroCtaBar(filteredDesigns);
    renderDesigns(filteredDesigns);
    scrollToolbar();
  });

  // Hide Filters on Desktop
  document.querySelector('.hide-filters-btn').addEventListener('click', () => {
    filtersSidebar.classList.toggle('hidden');
    document.querySelector('.facets-vertical').classList.toggle('full-width');
    document.getElementById('hide-filters-btn').textContent =
      filtersSidebar.classList.contains('hidden') ? 'Show Filters' : 'Hide Filters';
  });

  // Grid option buttons
  const gridOptionBtns = document.querySelectorAll('.bg_nav_layoutnav__layout button');
  gridOptionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      gridOptionBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const columns = this.getAttribute('data-toggle-grid');
      document.getElementById('design-grid').className = `grid--${columns}-col-desktop grid`;
    });
  });
  window.addEventListener('resize', handleResize);
  handleResize();

  // Expand/collapse for filter groups
  document.querySelectorAll('.filter-group').forEach(group => {
    const title = group.querySelector('.filter-title');
    const checkboxGroup = group.querySelector('.checkbox-group');
    const icon = group.querySelector('.toggle-icon');
    const isOpen = group.getAttribute('data-default-open') !== 'false';
    checkboxGroup.style.display = isOpen ? 'block' : 'none';
    icon.textContent = isOpen ? '-' : '+';
    title.addEventListener('click', () => {
      const visible = checkboxGroup.style.display !== 'none';
      checkboxGroup.style.display = visible ? 'none' : 'block';
      icon.textContent = visible ? '+' : '-';
    });
  });
  const observer = new MutationObserver(setupShowMoreButtons);
  document.querySelectorAll('.filter-group .checkbox-group').forEach(group => {
    observer.observe(group, { childList: true, subtree: true });
  });

  // Expose globally
  window.changePage = changePage;
  window.clearSearch = clearSearch;
  window.resetFilters = resetFilters;
  window.filterDesigns = filterDesigns;

	
	
	
	function appendTargetingIDs(url, d) {
	  ['size','shape','orientation','corners','perforation','fold','fit','equipment']
		.forEach(attr => {
		  const id = d[`${attr}_targetingID`];
		  if (id) url += `&${attr}_targetingID=${encodeURIComponent(id)}`;
		});
	  return url;
	}	
	
	
  /* ============== GROUP DESIGNS IF NEEDED ============== */
function groupDesignsIfNeeded(allData) {
  const doGroup = (window.groupDesigns === 'true');
  if (!doGroup) {
    return allData;
  }

  const dMap = {};
  allData.forEach(d => {
    const designKey = getDesignKey(d);
    if (designKey) dMap[designKey] = d;
  });
  const used = new Set();
  const grouped = [];

  // Resolve a group for a given design:
  // Priority: suite group > manual linked string > singleton
  function resolveGroupNums(d) {
    const num = getDesignKey(d);
    const suiteKey = (d.design_suite ?? '').toString().trim();

    if (
      suiteKey &&
      window.designSuiteIndex &&
      Array.isArray(window.designSuiteIndex[suiteKey]) &&
      window.designSuiteIndex[suiteKey].length
    ) {
      return Array.from(new Set(window.designSuiteIndex[suiteKey].concat([num]))).filter(n => dMap[n]);
    }

    const linkedStr = (d['linked designs string'] || '').trim();
    if (linkedStr) {
      const linkedNums = linkedStr
        .split(',')
        .map(s => parseInt(s.trim(), 10))
        .filter(x => dMap[x]);
      return Array.from(new Set([num, ...linkedNums])).filter(x => dMap[x]);
    }

    return [num];
  }

  for (let d of allData) {
    const num = getDesignKey(d);
    if (!num) continue;
    if (used.has(num)) continue;

    const groupNums = resolveGroupNums(d);

    // Group by product
    const productMap = {};
    groupNums.forEach(n => {
      const item = dMap[n];
      if (!item) return;
      const pName = item.product || 'Unknown Product';
      if (!productMap[pName]) productMap[pName] = [];
      productMap[pName].push(item);
    });

    // Pick default per product (keeps your existing "linked design default" behavior)
    Object.keys(productMap).forEach(pName => {
      const arr = productMap[pName];

      let foundDefault = arr.find(x => {
        const defStr = (x['linked design default'] || '').trim();
        const defNum = parseInt(defStr, 10);
        return (defStr && defStr === getDesignKey(x)) || (defNum && defNum === x.designnum);
      });
      if (!foundDefault) {
        foundDefault = arr[0];
      }

      const foundKey = getDesignKey(foundDefault);
      if (foundKey && !used.has(foundKey)) {
        grouped.push(foundDefault);
        used.add(foundKey);
      }
    });
  }

  // Preserve your “URL param adds non-defaults” behavior
  const url = new URL(window.location.href);
  const shapeParam = url.searchParams.get('shape');
  const sizeParam  = url.searchParams.get('size');
  const orientParam= url.searchParams.get('orientation');
  const hasParam = (shapeParam || sizeParam || orientParam);

  if (hasParam) {
    function matchesParam(item) {
      if (shapeParam && (item.shape || '').toLowerCase() === shapeParam.toLowerCase()) return true;
      if (sizeParam && sizeParamMatchesItem(item, sizeParam)) return true;
      if (orientParam && (item.orientation || '').toLowerCase() === orientParam.toLowerCase()) return true;
      return false;
    }
    for (let d of allData) {
      const designKey = getDesignKey(d);
      if (!designKey) continue;
      if (used.has(designKey)) continue;
      if (matchesParam(d)) {
        grouped.push(d);
        used.add(designKey);
      }
    }
  }

  return grouped;
}


	
	let isFirstFilter = true;

  function getSizeDisplayValue(design) {
    if (!design) return '';
    const sda = (design.size_display_as || '').toString().trim();
    if (sda) return sda;
    return (design.size || '').toString().trim();
  }

  function getFilterFieldValue(design, field) {
    if (field === 'size') return getSizeDisplayValue(design);
    return design ? design[field] : null;
  }

  function sizeParamMatchesItem(item, sizeParam) {
    if (!item || !sizeParam) return false;
    const want = sizeParam.toLowerCase();
    const display = getSizeDisplayValue(item).toLowerCase();
    const raw = (item.size || '').toString().trim().toLowerCase();
    return (display && display === want) || (raw && raw === want);
  }

  let searchSuggestions = [];
  let activeSuggestionIndex = -1;

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[“”]/g, '"')
      .replace(/[’]/g, "'")
      .replace(/(\d+(?:\.\d+)?)(\"|')?\s*[\u00D7x]\s*(\d+(?:\.\d+)?)(\"|')?/g, '$1$2 x $3$4')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getSearchState() {
    const query = normalizeSearchValue(searchInput.value);
    if (!query) return { query: '', tokens: [] };
    const tokens = query.split(' ').filter(Boolean);
    return { query, tokens };
  }

  function getSearchableValues(design) {
    if (!design) return [];
    const values = [];
    SEARCH_FIELDS.forEach(field => {
      if (field === 'size') {
        const display = getSizeDisplayValue(design);
        const raw = (design.size || '').toString().trim();
        if (display) values.push(display);
        if (raw && raw !== display) values.push(raw);
        return;
      }
      const v = design[field];
      if (v == null) return;
      if (Array.isArray(v)) {
        v.forEach(item => {
          if (typeof item === 'string' || typeof item === 'number') values.push(item);
        });
      } else if (typeof v === 'string' || typeof v === 'number') {
        values.push(v);
      }
    });
    return values.map(normalizeSearchValue).filter(Boolean);
  }

  function matchesSearch(design, searchState) {
    if (!searchState.query) return true;
    const values = getSearchableValues(design);
    if (!values.length) return false;
    if (values.some(v => v.includes(searchState.query))) return true;
    return searchState.tokens.every(t => values.some(v => v.includes(t)));
  }

  function hideSearchSuggestions() {
    if (!suggestionsContainer) return;
    searchSuggestions = [];
    activeSuggestionIndex = -1;
    suggestionsContainer.innerHTML = '';
    suggestionsContainer.style.display = 'none';
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function applySearchSuggestion(value) {
    if (!searchInput) return;
    searchInput.value = value;
    clearSearchButton.style.display = value ? 'block' : 'none';
    hideSearchSuggestions();
    filterDesigns();
  }

  function setActiveSuggestion(index) {
    if (!suggestionsContainer) return;
    activeSuggestionIndex = index;
    const items = Array.from(suggestionsContainer.querySelectorAll('[data-index]'));
    items.forEach((item, i) => {
      const isActive = i === activeSuggestionIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) {
        item.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  function handleSearchKeydown(e) {
    if (!searchInput) return;
    const hasSuggestions = suggestionsContainer && suggestionsContainer.style.display === 'block';
    if (!hasSuggestions) {
      if (e.key === 'Enter') {
        e.preventDefault();
        filterDesigns();
      } else if (e.key === 'Escape') {
        hideSearchSuggestions();
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = activeSuggestionIndex + 1;
      setActiveSuggestion(next >= searchSuggestions.length ? 0 : next);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = activeSuggestionIndex - 1;
      setActiveSuggestion(prev < 0 ? searchSuggestions.length - 1 : prev);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeSuggestionIndex >= 0 && searchSuggestions[activeSuggestionIndex]) {
        applySearchSuggestion(searchSuggestions[activeSuggestionIndex]);
      } else {
        hideSearchSuggestions();
        filterDesigns();
      }
    } else if (e.key === 'Escape') {
      hideSearchSuggestions();
    }
  }

  /* =============== 2) FILTER DESIGN FUNCTION =============== */
  function filterDesigns() {
    currentPage = 1;
    window.currentPage = currentPage;
    renderProductSwatchRow(getFilteredDesigns({ ignoreProductSwatch: true }));
    const filtered = getFilteredDesigns();
    const pages = Math.ceil(filtered.length / itemsPerPage);
    updatePaginationControls(pages);
    renderHeroCtaBar(filtered);
    renderDesigns(filtered);
    updateFilterOptions();
    updateSelectedFilters();
    updateResultsCount();
					  
	  if (!__suppressURLSync) {
		syncURLWithState();  
	  }					  
					  
    if (!isFirstFilter) scrollToolbar();
    isFirstFilter = false;
  }

  function scrollToolbar() {
    const target = window.matchMedia('(max-width: 749px)').matches
      ? document.querySelector('#bg-toolbar')
      : document.querySelector('#sort-buttons');
    if (!target) return;
    window.scrollTo({
      top: target.offsetTop - 20,
      behavior: 'smooth'
    });
  }

  /* =============== 3) SEARCH SUGGESTIONS =============== */
  function initializeSearchSuggestions() {
    let nGramMap = new Map();
    let displayMap = new Map();

    function rebuildSearchSuggestionIndex() {
      nGramMap = new Map();
      displayMap = new Map();
      const arr = window.filterSourceData || [];

      arr.forEach(d => {
        if (shouldExcludeDesign(d)) return;
        const fieldsToCheck = SEARCH_SUGGESTION_FIELDS;
        fieldsToCheck.forEach(field => {
          const fv = getFilterFieldValue(d, field);
          if (!fv) return;
          const vals = Array.isArray(fv) ? fv : [fv];
          vals.forEach(val => {
            const display = (typeof val === 'string' || typeof val === 'number')
              ? String(val).trim()
              : '';
            if (!display) return;
            const normalized = normalizeSearchValue(display);
            if (!normalized) return;
            if (!displayMap.has(normalized)) displayMap.set(normalized, display);
            generateNGrams(normalized).forEach(ng => {
              if (!nGramMap.has(ng)) {
                nGramMap.set(ng, new Set());
              }
              nGramMap.get(ng).add(normalized);
            });
          });
        });
      });
    }

    rebuildSearchSuggestionIndex();
    bgRebuildSearchSuggestionIndex = rebuildSearchSuggestionIndex;
    searchInput.addEventListener('input', debounce(() => {
      const query = normalizeSearchValue(searchInput.value);
      if (!query) {
        hideSearchSuggestions();
        return;
      }
      const queryNgrams = generateNGrams(query);
      const potential = new Set();
      queryNgrams.forEach(ng => {
        if (nGramMap.has(ng)) {
          nGramMap.get(ng).forEach(match => potential.add(match));
        }
      });
      const filteredKeywords = Array.from(potential).filter(k => advancedMatch(query, k));
      const displayValues = Array.from(new Set(filteredKeywords.map(k => displayMap.get(k) || k)));
      displayValues.sort((a, b) => {
        const aNorm = normalizeSearchValue(a);
        const bNorm = normalizeSearchValue(b);
        const aStarts = aNorm.startsWith(query);
        const bStarts = bNorm.startsWith(query);
        if (aStarts !== bStarts) return aStarts ? -1 : 1;
        return aNorm.localeCompare(bNorm);
      });
      showSuggestions(displayValues);
    }, SEARCH_DEBOUNCE_MS));
  }

  function advancedMatch(query, keyword) {
    const q = normalizeSearchValue(query);
    const k = normalizeSearchValue(keyword);
    if (!q) return false;
    const maxDist = Math.ceil(q.length / 2);
    const dist = levenshteinDistance(q, k);
    if (k.includes(q)) return true;
    if (k.startsWith(q)) return true;
    if (dist <= maxDist) return true;
    // basic overlap measure
    const qSet = generateNGrams(q);
    const kSet = generateNGrams(k);
    const intersect = new Set([...qSet].filter(x => kSet.has(x)));
    const ratio = intersect.size / Math.max(qSet.size, kSet.size);
    return ratio > 0.4;
  }

  function showSuggestions(keywords) {
    if (!suggestionsContainer) return;
    const list = keywords.slice(0, 10);
    if (!list.length) {
      hideSearchSuggestions();
      return;
    }
    suggestionsContainer.innerHTML = '';
    searchSuggestions = list;
    activeSuggestionIndex = -1;
    list.forEach((kw, idx) => {
      const div = document.createElement('div');
      div.textContent = kw;
      div.title = kw;
      div.dataset.index = String(idx);
      div.setAttribute('role', 'option');
      div.setAttribute('aria-selected', 'false');
      div.addEventListener('mousedown', (e) => {
        e.preventDefault();
        applySearchSuggestion(kw);
      });
      suggestionsContainer.appendChild(div);
    });
    suggestionsContainer.style.display = 'block';
    if (searchInput) searchInput.setAttribute('aria-expanded', 'true');
  }

  /* =============== 4) FILTER / CHECKBOX POPULATION =============== */
  function populateFilters() {
    updateFilterOptions();
    setupShowMoreButtons();
  }

function updateFilterOptions() {
  const searchState = getSearchState();

  // Determine which checkboxes are currently selected
  const selected = {};
  filterFields.forEach(f => {
    selected[f.field] = getSelectedValues(f.id);
  });

  // Build up the potential filter sets
  const filterSets = {};
  filterFields.forEach(f => {
    filterSets[f.field] = new Map();
  });

  const arr = window.filterSourceData || [];


const brandOnly       = (window.onlyShowBrandTemplates === true 
                      || window.onlyShowBrandTemplates === 'true');
const userStorefront  = (window.storefront || '').toLowerCase();

arr.forEach(d => {

  if (shouldExcludeDesign(d)) return;
  if (!bgDesignMatchesSelectedSwatch(d)) return;

  // 1) STOREFRONT CHECK
  if (brandOnly) {
    // only show brand-labeled designs that match the userÃ¢â‚¬â„¢s storefront
    if (!d.storefront || d.storefront.toLowerCase() !== userStorefront) {
      return; // skip
    }
  } else {
    // allow universal if no storefront
    // but if design *does* have .storefront, it must match
    if (d.storefront && d.storefront.toLowerCase() !== userStorefront) {
      return; // skip
    }
  }
	  
	  
    // ==== ADDED LINES TO SKIP PLACEHOLDERS ====
    const name = (d['template_name'] || '').trim().toLowerCase();
    if (name === 'start from scratch' || name === 'upload completed design') {
      // Skip adding this design to the filter counts
      return;
    }
    // ==========================================

    // 1) Check if it matches the text search
    const matchedSearch = matchesSearch(d, searchState);

    // 2) Check if it matches the currently selected filters
    const matchedFilters = filterFields.every(f => {
      const selVals = selected[f.field];
      if (!selVals.length) return true; // no filters selected for this field
      const dv = getFilterFieldValue(d, f.field);
      if (!dv) return false; // design has no value for this field
      if (Array.isArray(dv)) {
        return dv.some(i => selVals.some(s => i && i.toLowerCase() === s.toLowerCase()));
      } else if (typeof dv === 'string') {
        return selVals.some(s => dv.toLowerCase() === s.toLowerCase());
      }
      return false;
    });

    if (matchedSearch && matchedFilters) {
      // This design should contribute to the possible filter values
      filterFields.forEach(f => {
        const dv = getFilterFieldValue(d, f.field);
        if (!dv) return;
        const arrVal = Array.isArray(dv) ? dv : [dv];
        arrVal.forEach(val => {
          if (!val) return;
          const currentCount = filterSets[f.field].get(val) || 0;
          filterSets[f.field].set(val, currentCount + 1);
        });
      });
    }
  });

  // Now we have a map of all possible filter values => counts for each field
  // Re-populate the checkbox groups
  filterFields.forEach(f => {
    populateCheckboxGroup(f.id, filterSets[f.field], selected[f.field], f.field);
  });

  updateShowResultsCount();
}


  function getSelectedValues(filterId) {
    return Array.from(document.querySelectorAll(`#${filterId} input[type="checkbox"]:checked`))
      .map(cb => cb.value);
  }

  function populateCheckboxGroup(filterId, valueMap, selectedValues, fieldName) {
	  const filterEl = document.getElementById(filterId);
	  if (!filterEl) return;
	  const filterGroup = filterEl.closest('.filter-group');

// If there are no values at all, hide and return
if (valueMap.size === 0) {
  filterGroup.style.display = 'none';
  return;
}

// If there is exactly 1 distinct value, check if *all* results share it
if (valueMap.size === 1) {
  // We only want to hide the filter if EVERY matched design has this value
  const singleVal = Array.from(valueMap.keys())[0];
  const valCount  = valueMap.get(singleVal) || 0;

  // Count how many designs are in the current filtered set
  const totalResults = getFilteredDesigns().length;

  if (valCount === totalResults) {
    // That means 100% of the results have the same value => no refinement possible
    filterGroup.style.display = 'none';
    return;
  }
}

// Otherwise, show the group
filterGroup.style.display = 'block';
filterEl.innerHTML = '';


    let sortedVals = Array.from(valueMap.keys());
    if (['size','shape'].includes(fieldName)) {
      sortedVals.sort(customSizeShapeSort);
    } else {
      sortedVals.sort((a,b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }

    sortedVals.forEach(val => {
      if (!val.trim()) return;
      const label = document.createElement('label');
      const textSpan = document.createElement('span');
      textSpan.textContent = val;
      textSpan.className = 'filter-title';
      const countSpan = document.createElement('span');
      countSpan.textContent = ` (${valueMap.get(val)})`;
      countSpan.className = 'filter-count';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = val;
      checkbox.className = 'filter-checkbox';
      if (selectedValues.some(s => s.toLowerCase() === val.toLowerCase())) {
        checkbox.checked = true;
      }
      checkbox.onchange = filterDesigns;

      label.append(textSpan, countSpan, checkbox);
      filterEl.appendChild(label);
    });
  }

  function customSizeShapeSort(a,b) {
    const pA = parsePhysicalDimension(a);
    const pB = parsePhysicalDimension(b);
    if (pA && pB) {
      if (pA[0]!==pB[0]) return pA[0]-pB[0];
      return pA[1]-pB[1];
    } else if (pA && !pB) return -1;
    else if (!pA && pB) return 1;
    return a.localeCompare(b);
  }

  function parsePhysicalDimension(str) {
    if (!str) return null;
    const matchInches = str.match(/^(\d*\.?\d+)"?\s*x\s*(\d*\.?\d+)"?/i);
    if (matchInches) {
      const w = parseFloat(matchInches[1]);
      const h = parseFloat(matchInches[2]);
      return [w,h];
    }
    const matchFeet = str.match(/^(\d*\.?\d+)'?\s*x\s*(\d*\.?\d+)'?/i);
    if (matchFeet) {
      const w = parseFloat(matchFeet[1]) * 12;
      const h = parseFloat(matchFeet[2]) * 12;
      return [w,h];
    }
    return null;
  }

  function updateShowResultsCount() {
    const f = getFilteredDesigns();
    showResultsBtn.textContent = `Show ${f.length} Results`;
  }

  
/* =====================================
   2) SELECT WHICH ARRAY & FILTER LOGIC
   ===================================== */
function getFilteredDesigns(options = {}) {
  // Decide if grouping is active:
  // We only use the grouped array if:
  //   (1) groupDesigns === 'true'
  //   (2) shape-filter is not selected
  //   (3) size-filter is not selected
  //   (4) orientation-filter is not selected
  const shapeSel      = getSelectedValues('shape-filter');
  const sizeSel       = getSelectedValues('size-filter');
  const orientationSel= getSelectedValues('orientation-filter');

  const groupingActive =
    (window.groupDesigns === 'true') &&
    (shapeSel.length === 0) &&
    (sizeSel.length === 0) &&
    (orientationSel.length === 0);

  // pick the correct master array
  const arr = groupingActive
    ? window.allDesignsGrouped
    : window.allDesignsUngrouped;

  // Now proceed with your existing filter + search checks
  const selected = {};
  filterFields.forEach(f => (selected[f.field] = getSelectedValues(f.id)));
  const searchState = getSearchState();

	
  // 2) The brand Ã¢â‚¬Å“onlyShowBrandTemplatesÃ¢â‚¬Â toggle
  const brandOnly = (window.onlyShowBrandTemplates === true 
                     || window.onlyShowBrandTemplates === 'true');
  const userStorefront = (window.storefront || '').toLowerCase();	
	
	
  // Final array = arr filtered by placeholders, plus search and checkboxes
  return arr.filter(d => {
    if (shouldExcludeDesign(d)) return false;
    if (!options.ignoreProductSwatch && !bgDesignMatchesSelectedSwatch(d)) return false;
	  
	const name = (d['template_name'] || '').trim().toLowerCase();
    if (name === 'start from scratch' || name === 'upload completed design') {
      return false;
    }
	  
    // B) only_show_brand_templates = 'true' => design MUST have .storefront = userÃ¢â‚¬â„¢s brand
    if (brandOnly) {
      // If the design doesnÃ¢â‚¬â„¢t have a storefront or it doesnÃ¢â‚¬â„¢t match userStorefront => exclude
      if (!d.storefront || d.storefront.toLowerCase() !== userStorefront) {
        return false;
      }
    } else {
      // Normal logic: If design does have a storefront, it must match
      if (d.storefront && d.storefront.toLowerCase() !== userStorefront) {
        return false;
      }
      // If design has no storefront, itÃ¢â‚¬â„¢s considered universal => keep it
    }

    // Check text search
    const matchSearch = matchesSearch(d, searchState);

    // Check selected filters
    const matchFilters = filterFields.every(f => {
      const selVals = selected[f.field];
      if (!selVals.length) return true;
      const dv = getFilterFieldValue(d, f.field);
      if (!dv) return false;
      if (Array.isArray(dv)) {
        return dv.some(i => selVals.some(s => i && i.toLowerCase() === s.toLowerCase()));
      } else if (typeof dv === 'string') {
        return selVals.some(s => dv.toLowerCase() === s.toLowerCase());
      }
      return false;
    });

    return matchSearch && matchFilters;
  });
}
	
	
/**
 * pepperedInSort(items)
 *
 * 1) Splits items into:
 *    - normalItems (no "peppered in" tag)
 *    - pepperedItems (with "peppered in" tag)
 * 2) Sorts each group by 'date-created' descending
 * 3) Randomly inserts pepperedItems back into normalItems
 *    so they appear sporadically, not at the front or back.
 */
function pepperedInSort(items) {
  // 1) Separate
  const pepperedItems = [];
  const normalItems   = [];

  items.forEach(d => {
    // Convert tags to lowercase, check if "peppered in" is present
    const tags = (d.tags || []).map(t => t.toLowerCase().trim());
    if (tags.includes('peppered in')) {
      pepperedItems.push(d);
    } else {
      normalItems.push(d);
    }
  });

  // 2) Sort each group by date descending
  normalItems.sort((a, b) => {
    const dA = new Date(a['date-created'] || '1970-01-01');
    const dB = new Date(b['date-created'] || '1970-01-01');
    return dB - dA;
  });
  pepperedItems.sort((a, b) => {
    const dA = new Date(a['date-created'] || '1970-01-01');
    const dB = new Date(b['date-created'] || '1970-01-01');
    return dB - dA;
  });

  // 3) Insert pepperedItems into normalItems at random positions
  // so they're scattered rather than at front or end.
  // 
  // For each peppered item, pick a random insertion index
  // that isn't the very front or very end. 
  // You can tweak the minIdx / maxIdx logic as desired.
  const minIdx = 1;
  const maxIdx = Math.max(1, normalItems.length - 1);

  pepperedItems.forEach((pep) => {
    const randomIndex = Math.floor(Math.random() * (maxIdx - minIdx + 1)) + minIdx;
    normalItems.splice(randomIndex, 0, pep);
  });

  // 4) Place the combined array back into 'items' (mutating it in place).
  // The 'renderDesigns()' function will see the updated order.
  for (let i = 0; i < normalItems.length; i++) {
    items[i] = normalItems[i];
  }
  // If peppered had more items than the normal space, we might push them
  items.length = normalItems.length; 
}
	

// === 1) Add these helpers (place ABOVE renderDesigns) =======================
function isBackOfBus(design) {
  // tag match is case/space tolerant
  const tags = Array.isArray(design?.tags) ? design.tags : [];
  const taggedBack = tags.some(t => (t || '').trim().toLowerCase() === 'back of the bus');
  const flaggedBack = bgNormalizeDesignBool(design?.to_the_back) === true;
  return taggedBack || flaggedBack;
}

// Stable-partition with optional per-group shuffle for the 'random' mode
function applyBackOfBusRule(items, sortMode) {
  const front = [];
  const back  = [];
  for (const d of items) {
    (isBackOfBus(d) ? back : front).push(d);
  }

  // If Random is selected, randomize within each partition but keep back group last
  if (sortMode === 'random') {
    const shuffle = (arr) => {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    };
    shuffle(front);
    shuffle(back);
  }

  return front.concat(back);
}






	

  /* =============== 5) RENDERING THE GRID =============== */
  function renderDesigns(filtered) {
  const designGrid = document.getElementById('design-grid');
  designGrid.innerHTML = '';

  // Work on a copy so we don't mutate the original filtered set
  let working = filtered.slice();

  // Sorting
  const sortOption = sortSelect.value;

  if (sortOption === 'random') {
    // shuffle both partitions later; we still shuffle now to keep parity with prior behavior
    // (final partitioning will re-shuffle within groups again to avoid bias)
    for (let i = working.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [working[i], working[j]] = [working[j], working[i]];
    }
  } else if (sortOption === 'newest') {
    working.sort((a, b) => {
      const dA = new Date(a['date-created'] || '1970-01-01');
      const dB = new Date(b['date-created'] || '1970-01-01');
      return dB - dA;
    });
  } else if (sortOption === 'most_popular') {
    working.sort((a, b) => (b['# Times Project Saved'] || 0) - (a['# Times Project Saved'] || 0));
  } else if (sortOption === 'default') {
    // your peppered-in sort mutates in place; pass the copy
    pepperedInSort(working);
  }

  // >>> Enforce "Back of the bus" AFTER the chosen sort <<<
  working = applyBackOfBusRule(working, sortOption);

  // Pagination slice
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex   = startIndex + itemsPerPage;
  const toShow     = working.slice(startIndex, endIndex);

  // 1) FIRST static item
  const startBlankHTML = `
<li class="bg_design_grid_item uploadOrDesignCustom custom-link-container" id="start-blank-static-item">
  <div class="card-wrapper underline-links-hover" swatch-generated="none">
    <div class="card card--standard card--media" style="--ratio-percent:70.118%;">
      <div class="card__content-uploadOrDesignCustom" style="padding:10px;">
        <img src="${fallbackProductImage}"
             class="startFromBlankImage" width="100%" height="auto" alt="Start from blank" style="margin-bottom:15px;" />
        <div class="staticItemBtns">
          <button class="startFromBlankBtn"><span aria-hidden="true" style="margin-right:5px;">📝</span>Start from blank</button>
        </div>       
      </div>
    </div>
  </div>
</li>`;
  designGrid.insertAdjacentHTML('beforeend', startBlankHTML);

  // 2) Insert the actual designs (+ optional mid “Need a Custom Design” card)
  const midItemHTML = `
    <li class="bg_design_grid_item uploadOrDesignCustom needACustomDesign noPopup custom-link-container extraMidDesignItem">
      <a href="/products/custom-design-services" id="customPopupTriggerMid">
        <div class="card-wrapper underline-links-hover" swatch-generated="none">
          <div class="card card--standard card--media" style="--ratio-percent:70.118%;">
            <div class="card__content-uploadOrDesignCustom card__content-needACustomDesign">
              <img src="https://cdn.shopify.com/s/files/1/0748/0206/9822/files/Custom-Design_656c9f59-9ff9-44da-814c-b596c487009e.png?v=1748106670"
                class="uploadYourOwnImage needACustomDesign" width="100%" height="auto">
              <span class="card_uploadOrDesignYourOwnSpan">
                Want a custom design?<br>We can help!<br>Click here.
              </span>
            </div>
          </div>
        </div>
      </a>
    </li>
  `;

  let insertedMidItem = false;
  toShow.forEach((d, idx) => {
    if (!insertedMidItem && toShow.length > 15 && idx === 6) {
      designGrid.insertAdjacentHTML('beforeend', midItemHTML);
      insertedMidItem = true;
    }
    const li = document.createElement('li');
    li.className = 'bg_design_grid_item';
    li.innerHTML = buildDesignCard(d);
    designGrid.appendChild(li);
  });

  // 3) FINAL static item
  const lastItemHTML = `
    <li class="bg_design_grid_item uploadOrDesignCustom needACustomDesign noPopup custom-link-container">
      <a href="/products/custom-design-services" id="customPopupTriggerNoPopup">
        <div class="card-wrapper underline-links-hover" swatch-generated="none">
          <div class="card card--standard card--media" style="--ratio-percent:70.118%;">
            <div class="card__content-uploadOrDesignCustom card__content-needACustomDesign">
              <img src="https://cdn.shopify.com/s/files/1/0748/0206/9822/files/need-a-design-icon.png?v=1705530759"
                class="uploadYourOwnImage needACustomDesign" width="100%" height="auto">
              <span class="card_uploadOrDesignYourOwnSpan">
                Need a design?<br>Want something custom?<br>We've got you!
              </span>
            </div>
          </div>
        </div>
      </a>
    </li>`;
  designGrid.insertAdjacentHTML('beforeend', lastItemHTML);

  attachEventListenersToGridItems();
  initStackedPreviewToggles(designGrid);
  initPobWarp(designGrid);
  attachStaticItemButtonHandlers();
}
	
	
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}	




/* --- Helpers for the image warping ------------------- */

// Homography math (unit square -> arbitrary quad)
function _homographyForUnitToQuad(x0,y0, x1,y1, x2,y2, x3,y3) {
  const dx1 = x1 - x2, dy1 = y1 - y2;
  const dx2 = x3 - x2, dy2 = y3 - y2;
  const dx3 = x0 - x1 + x2 - x3, dy3 = y0 - y1 + y2 - y3;
  const det = dx1*dy2 - dx2*dy1;
  let a13 = 0, a23 = 0;
  if (det !== 0) {
    a13 = (dx3*dy2 - dx2*dy3) / det;
    a23 = (dx1*dy3 - dx3*dy1) / det;
  }
  const a11 = x1 - x0 + a13 * x1;
  const a12 = x3 - x0 + a23 * x3;
  const a21 = y1 - y0 + a13 * y1;
  const a22 = y3 - y0 + a23 * y3;
  return [a11, a12, x0,  a21, a22, y0,  a13, a23, 1];
}

function _cssMatrix3dFromHomography(H, W, H_) {
  const h11 = H[0] / W,  h12 = H[1] / H_,  h13 = H[2];
  const h21 = H[3] / W,  h22 = H[4] / H_,  h23 = H[5];
  const h31 = H[6] / W,  h32 = H[7] / H_,  h33 = H[8];

  return `matrix3d(${h11}, ${h21}, 0, ${h31},  ${h12}, ${h22}, 0, ${h32},  0, 0, 1, 0,  ${h13}, ${h23}, 0, ${h33})`;
}


function applyPobWarpTo(el, params) {
  const wrap = el?.parentElement;
  if (!wrap) return;

  // ensure we have layout
  const rQuad = el.getBoundingClientRect();
  let W = rQuad.width, H = rQuad.height;
  if (W < 2 || H < 2) {
    requestAnimationFrame(() => applyPobWarpTo(el, params));
    return;
  }

  const rWrap = wrap.getBoundingClientRect();

  // helpers
  const num = (v) => (v === null || v === undefined || v === '' ? null : (isFinite(+v) ? +v : null));
  const pct = (v) => (isFinite(+v) ? (+v) * 0.01 : 0);

  // read JSON offsets (percent wins) …
  let offXPct = num(params.preview_offset_x_pct) ?? num(params.image_pob_preview_offset_x_pct);
  let offYPct = num(params.preview_offset_y_pct) ?? num(params.image_pob_preview_offset_y_pct);
  let offXPx  = num(params.preview_offset_x_px)  ?? num(params.image_pob_preview_offset_x_px) ?? 0;
  let offYPx  = num(params.preview_offset_y_px)  ?? num(params.image_pob_preview_offset_y_px) ?? 0;

  // DEV OVERRIDE: if you hand-set --pob-x/--pob-y on the wrapper, use those
  const cs = getComputedStyle(wrap);
  const devX = cs.getPropertyValue('--pob-x').trim();
  const devY = cs.getPropertyValue('--pob-y').trim();
  if (devX) {
    if (devX.endsWith('%')) { offXPct = parseFloat(devX); offXPx = 0; }
    else if (devX.endsWith('px') || !isNaN(+devX)) { offXPct = null; offXPx = parseFloat(devX); }
  }
  if (devY) {
    if (devY.endsWith('%')) { offYPct = parseFloat(devY); offYPx = 0; }
    else if (devY.endsWith('px') || !isNaN(+devY)) { offYPct = null; offYPx = parseFloat(devY); }
  }

  // scale (art scale, not background)
  const sRaw = num(params.preview_scale);
  const s = (sRaw && sRaw > 0) ? sRaw : 1;

  // size of the art box we warp
  const SW = W * s;
  const SH = H * s;

  // offsets: % is relative to the ART size (parity with non-warp)
  const ox = (offXPct !== null) ? (offXPct * 0.01 * SW) : offXPx;
  const oy = (offYPct !== null) ? (offYPct * 0.01 * SH) : offYPx;

  // <<< NEW: center inside wrapper, then apply ox/oy >>> 
  const cx = (rWrap.width  - SW) * 0.5;   // center X in wrapper
  const cy = (rWrap.height - SH) * 0.5;   // center Y in wrapper
  const tx = cx + ox;
  const ty = cy + oy;

  // corner warp (percent of scaled art)
  const w = params.warp || {};
  let tlx = 0 + pct(w.tl_x_pct) * SW,  tly = 0 + pct(w.tl_y_pct) * SH;
  let trx = SW + pct(w.tr_x_pct) * SW, tryy = 0 + pct(w.tr_y_pct) * SH;
  let brx = SW + pct(w.br_x_pct) * SW, bry  = SH + pct(w.br_y_pct) * SH;
  let blx = 0 + pct(w.bl_x_pct) * SW,  bly  = SH + pct(w.bl_y_pct) * SH;

  // homography (element space W×H → warped, scaled quad at origin)
  const Hmat = _homographyForUnitToQuad(tlx, tly, trx, tryy, brx, bry, blx, bly);
  const M = _cssMatrix3dFromHomography(Hmat, W, H);

  // compose final transform = matrix then post-translate (center + offsets)
  const T = `translate(${tx}px, ${ty}px)`;

  // expose as CSS vars (and also inline as a safety fallback)
  el.style.setProperty('--pob-matrix', M);
  el.style.setProperty('--pob-post', T);
  el.style.transformOrigin = '0 0';
  el.style.transform = `${M} ${T}`;

  // mirror for DevTools visibility
  wrap.style.setProperty('--pob-scale', String(s));

  if (window.DEBUG_POB === true) {
    console.debug('[POB][warp]', {W,H, SW,SH, wrapW:rWrap.width, wrapH:rWrap.height, cx,cy, ox,oy, tx,ty, warp:w});
    el.style.outline = '1px dashed rgba(255,0,0,.35)';
  }
}






function bgNormalizeDesignBool(value) {
  if (value === true || value === false) return value;
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    if (v === 'true') return true;
    if (v === 'false') return false;
  }
  return null;
}

function bgNormalizeDesignText(value) {
  return String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
}

function bgIsEditServiceOnlyDesign(d) {
  return bgNormalizeDesignText(d?.editability) === 'edit service only';
}

function bgShouldShowAiGeneratedTemplateDisclaimer(d) {
  return bgNormalizeDesignBool(d?.include_ai_gen_disclaimer) === true;
}

function bgConfirmAiGeneratedEditServiceTemplate(d) {
  if (!bgShouldShowAiGeneratedTemplateDisclaimer(d)) return true;
  return window.confirm(
    'This design template mockup was generated with AI. AI-generated images are not editable, high resolution, or print ready, and would print poorly as-is.\n\n' +
    'If you proceed with this template, our professional designers will recreate the design as a real layered, high-resolution, print-ready file using this mockup as inspiration. The final design may not be a 1:1 exact match.\n\n' +
    'We can customize the inspiration to match your branding and services.\n\nConfirm to continue.'
  );
}

// BD-B66 (same rule as the product page runtime): a card opens online only
// through a Studio template lookup or a real old-editor design id. A legacy row
// with an empty design id carries its Foundation row id (or a made-up
// designnum:/legacy: id) there instead, which no editor can open.
function bgDesignHasEditorSource(d) {
  const text = (value) => String(value ?? '').trim();
  if (text(d?.template_lookup || d?.templateLookup || d?.template_public_id
    || d?.templatePublicId || d?.public_id || d?.publicId)) return true;
  const designId = text(d?.id);
  if (!designId || designId === text(d?.__foundationTemplateId)) return false;
  return !/^(?:designnum:|legacy:|legacy_design_template_)/.test(designId);
}

function bgGetDesignAvailability(d) {
  const onlineFlag = bgNormalizeDesignBool(d?.design_online_available);
  const legacyFlag = bgNormalizeDesignBool(d?.legacy_template) === true;
  const editFlag = bgNormalizeDesignBool(d?.edit_service_available);
  const editServiceOnly = bgIsEditServiceOnlyDesign(d);
  const downloadFlag = bgNormalizeDesignBool(d?.digital_download_available) === true;
  const hasEditCost = d?.edit_service_cost !== undefined && d?.edit_service_cost !== null;
  const canEdit = editServiceOnly || editFlag === true || (editFlag !== false && hasEditCost);
  const isOnline = !editServiceOnly && onlineFlag !== false && bgDesignHasEditorSource(d);
  const isLegacy = legacyFlag || !isOnline;
  return { isOnline, isLegacy, canEdit, canDownload: downloadFlag };
}

function bgGetLegacyBadgeText(d) {
  const avail = bgGetDesignAvailability(d);
  if (!avail.isLegacy) return '';
  if (avail.canEdit && avail.canDownload) return 'Edit service or download only';
  if (avail.canEdit) return 'Edit service only';
  if (avail.canDownload) return 'Download only';
  return 'Not available online';
}

// Customers see how they can finish the design; "legacy" is staff wording.
function bgGetLegacyNote(d) {
  return bgGetLegacyBadgeText(d);
}

function initPobWarp(root) {
  const quads = (root || document).querySelectorAll('.pob-quad');
  quads.forEach(q => {
    const raw = q.dataset.pob || '';
    let pobParams = null;
    try { pobParams = raw ? JSON.parse(decodeURIComponent(raw)) : null; } catch(e){ pobParams = null; }
    if (!pobParams || !pobParams.warp) return;   // nothing to do

    // Recompute after layout is ready
    requestAnimationFrame(() => applyPobWarpTo(q, pobParams));
  });
}

window.initPobWarp = initPobWarp;
window.applyPobWarpTo = applyPobWarpTo;

// Re-apply on resize so % offsets stay aligned
let _pobWarpResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(_pobWarpResizeTimer);
  _pobWarpResizeTimer = setTimeout(() => initPobWarp(document), 60);
});











/* --- Helpers for the grid stacked preview ------------------- */

function bcParseARFromSize(sizeStr) {
  if (!sizeStr) return null;
  // reuse your existing parsePhysicalDimension if you prefer
  const mIn = sizeStr.match(/^(\d*\.?\d+)"?\s*x\s*(\d*\.?\d+)"?/i);
  if (mIn) {
    const w = parseFloat(mIn[1]), h = parseFloat(mIn[2]);
    if (w > 0 && h > 0) return w / h;
  }
  const mFt = sizeStr.match(/^(\d*\.?\d+)'?\s*x\s*(\d*\.?\d+)'?/i);
  if (mFt) {
    const w = parseFloat(mFt[1]) * 12, h = parseFloat(mFt[2]) * 12;
    if (w > 0 && h > 0) return w / h;
  }
  return null;
}


/* Resolve what style to use for a design */
function getPreviewStyleForDesign(d) {
  const style  = (d.image_preview_style || '').toLowerCase().trim();
  const params = d.image_preview_params || {};

  // Explicitly supported styles
  if (style === 'stacked_2pages')       return { style, params };
  if (style === 'place_on_background') return { style, params };
  if (style === 'single')               return { style: 'single', params: {} };

  // Missing/unknown => legacy single
  return { style: 'single', params: {} };
}

/* Build the HTML for the grid image area based on style */
function renderGridPreviewHTML(d) {
  const { style, params } = getPreviewStyleForDesign(d);
  const previews = Array.isArray(d.previews) ? d.previews : [];

  // Fallbacks for missing images
  const frontSrc = previews[0] || d.design_preview_url || '';
  


// ================== place_on_background ==================
if (style === 'place_on_background' && params?.bg_url && frontSrc) {
  // Aspect ratio for the container
  let ar = 1.5;
  if (params.aspect_ratio === 'from_size') {
    const computed = bcParseARFromSize(d.size || '');
    if (computed) ar = computed;
  } else if (typeof params.aspect_ratio === 'number' && isFinite(params.aspect_ratio) && params.aspect_ratio > 0) {
    ar = params.aspect_ratio;
  }

  // Helpers for unit-aware offsets
  const ux = (pct, px) => (typeof pct === 'number') ? `${pct}%` : `${px ?? 0}px`;
  const uy = ux;

  // Common (container) CSS vars
  const baseVars = [
    `--pob-ar:${ar}`,
    `--pob-bg: url('${params.bg_url.replace(/'/g, "\\'")}')`,
    `--pob-bg-size:${params.bg_fit || 'contain'}`,
    `--bc-shadow-x:${(params.shadow_offset_x_px ?? 0)}px`,
    `--bc-shadow-y:${(params.shadow_offset_y_px ?? 10)}px`,
    `--bc-shadow-blur:${(params.shadow_blur_px ?? 18)}px`,
    `--bc-shadow-color:${(params.shadow_color ?? 'rgba(0,0,0,.18)')}`,
    `--bc-radius:${(params.border_radius_px ?? 14)}px`
  ].join(';');


  

  // When WARP IS PRESENT -> render a quad host we can projectively warp
  if (params.warp) {
    // Art aspect ratio (from the design size) so the quad has proper height
    let artAR = ar; // fallback
    const parsed = bcParseARFromSize(d.size || '');
    if (parsed) artAR = parsed;

    // Width of the art inside the container; quad height derives from aspect-ratio
    const artWidthVar = `--pob-art-w:${(params.preview_width_pct ?? 80)}%`;

    return `
      <div class="pob-wrapper" style="${baseVars}">
      <div class="pob-quad"
      data-pob='${encodeURIComponent(JSON.stringify(params))}'
      style="--pob-art-w:${params.preview_width_pct ?? 80}%; --pob-art-ar:${artAR};">
          <img src="${frontSrc}" alt="${(d.template_name||'')}" loading="lazy" decoding="async">
        </div>
        ${params.overlay_url ? `<img class="ov-img" src="${params.overlay_url}" alt="" loading="lazy" decoding="async"
             style="--ov-w:${(params.overlay_width_pct ?? 100)}%;
                    --ov-x:${ux(params.overlay_offset_x_pct, params.overlay_offset_x_px)};
                    --ov-y:${uy(params.overlay_offset_y_pct, params.overlay_offset_y_px)};
                    --ov-scale:${(params.overlay_scale ?? 1)};
                    --ov-rot:${(params.overlay_rotate_deg ?? 0)}deg">` : ''}
      </div>
    `;
  }

  // NO WARP (your existing placed-art behavior)
  const cssVars = [
    baseVars,
    `--pob-art-w:${(params.preview_width_pct ?? 80)}%`,
    `--pob-x:${ux(params.preview_offset_x_pct, params.preview_offset_x_px)}`,
    `--pob-y:${uy(params.preview_offset_y_pct, params.preview_offset_y_px)}`,
    `--pob-scale:${(params.preview_scale ?? 1)}`,
    `--pob-rot:${(params.preview_rotate_deg ?? 0)}deg`,
    `--ov-w:${(params.overlay_width_pct ?? 100)}%`,
    `--ov-x:${ux(params.overlay_offset_x_pct, params.overlay_offset_x_px)}`,
    `--ov-y:${uy(params.overlay_offset_y_pct, params.overlay_offset_y_px)}`,
    `--ov-scale:${(params.overlay_scale ?? 1)}`,
    `--ov-rot:${(params.overlay_rotate_deg ?? 0)}deg`
  ].join(';');

  return `
    <div class="pob-wrapper" style="${cssVars}">
      <img class="pob-art" src="${frontSrc}" alt="${(d.template_name||'')}" loading="lazy" decoding="async">
      ${params.overlay_url ? `<img class="ov-img" src="${params.overlay_url}" alt="" loading="lazy" decoding="async">` : ''}
    </div>
  `;
}



  const backSrc  = previews[1] || previews[0] || '';
  const shouldAutoStack = style === 'single' && frontSrc && backSrc && frontSrc !== backSrc;

// If style is not stacked (or we can't stack), render a single image.
// If overlay params exist, wrap in a positioned host so the overlay sits on top.
if ((style !== 'stacked_2pages' && !shouldAutoStack) || !frontSrc || !backSrc || frontSrc === backSrc) {
  if (!frontSrc) return '';

  // helper for unit-aware values (matches the other branches)
  const ux = (pct, px) => (typeof pct === 'number') ? `${pct}%` : `${px ?? 0}px`;
  const uy = ux;

  if (params && params.overlay_url) {
    const ovVars = [
      `--ov-w:${(params.overlay_width_pct ?? 100)}%`,
      `--ov-x:${ux(params.overlay_offset_x_pct, params.overlay_offset_x_px)}`,
      `--ov-y:${uy(params.overlay_offset_y_pct, params.overlay_offset_y_px)}`,
      `--ov-scale:${(params.overlay_scale ?? 1)}`,
      `--ov-rot:${(params.overlay_rotate_deg ?? 0)}deg`
    ].join(';');

    return `
      <div class="ov-basic" style="${ovVars}">
        <img src="${frontSrc}" alt="${(d.template_name||'')}" class="primaryDesignImage" loading="lazy" decoding="async">
        <img class="ov-img" src="${params.overlay_url}" alt="" loading="lazy" decoding="async">
      </div>
    `;
  }

  // No overlay => keep the simple image
  return `<img src="${frontSrc}" alt="${(d.template_name||'')}" class="primaryDesignImage" loading="lazy" decoding="async">`;
}

  // Compute aspect ratio
  let ar = 1.75;
  if (params && params.aspect_ratio === 'from_size') {
    const computed = bcParseARFromSize(d.size || '');
    if (computed) ar = computed;
  } else if (typeof params?.aspect_ratio === 'number' && isFinite(params.aspect_ratio) && params.aspect_ratio > 0) {
    ar = params.aspect_ratio;
  }

// helper to pick unit-aware values
const ux = (pct, px) => (typeof pct === 'number') ? `${pct}%` : `${px ?? 0}px`;
const uy = ux; // same logic

const cssVars = [
  `--bc-ar:${ar}`,
  `--bc-tilt:${(params.tilt_deg ?? -2)}deg`,
  `--bc-skew:${(params.skew_deg ?? -3)}deg`,
  `--bc-front-x:${ux(params.front_offset_x_pct, params.front_offset_x_px)}`,
  `--bc-front-y:${uy(params.front_offset_y_pct, params.front_offset_y_px)}`,
  `--bc-back-x:${ux(params.back_offset_x_pct,  params.back_offset_x_px)}`,
  `--bc-back-y:${uy(params.back_offset_y_pct,  params.back_offset_y_px)}`,
  `--bc-front-scale:${(params.front_scale ?? 1)}`,
  `--bc-back-scale:${(params.back_scale ?? 0.985)}`,
  `--bc-shadow-x:${(params.shadow_offset_x_px ?? 0)}px`,
  `--bc-shadow-y:${(params.shadow_offset_y_px ?? 10)}px`,
  `--bc-shadow-blur:${(params.shadow_blur_px ?? 18)}px`,
  `--bc-shadow-color:${(params.shadow_color ?? 'rgba(0,0,0,.18)')}`,
  `--bc-radius:${(params.border_radius_px ?? 14)}px`,
  `--bc-width:${(params.width_pct ?? 88)}%`,
  `--ov-w:${(params.overlay_width_pct ?? 100)}%`,
  `--ov-x:${ux(params.overlay_offset_x_pct, params.overlay_offset_x_px)}`,
  `--ov-y:${uy(params.overlay_offset_y_pct, params.overlay_offset_y_px)}`,
  `--ov-scale:${(params.overlay_scale ?? 1)}`,
  `--ov-rot:${(params.overlay_rotate_deg ?? 0)}deg`
].join(';');


  // Front on top, back underneath
  return `
    <div class="bc-stacked-preview" style="${cssVars}">
      <img class="bc-back"  src="${backSrc}"  alt="${(d.template_name||'')} back"  loading="lazy" decoding="async">
      <img class="bc-front" src="${frontSrc}" alt="${(d.template_name||'')} front" loading="lazy" decoding="async">
      ${params.overlay_url ? `<img class="ov-img" src="${params.overlay_url}" alt="" loading="lazy" decoding="async">` : ''}
      <div class="bc-stacked-controls" role="group" aria-label="Preview side">
        <button type="button"
                class="bc-toggle bc-toggle--front active"
                data-view="front" aria-pressed="true">Front</button>
        <button type="button"
                class="bc-toggle bc-toggle--back"
                data-view="back" aria-pressed="false">Back</button>
      </div>
    </div>
  `;
}




  function buildDesignCard(d) {

    const imagesHtml = renderGridPreviewHTML(d);

    const isNew = d.tags && d.tags.includes('New');
    const newBadgeHtml = isNew? `<div class="image-badge new-badge">New</div>`:'';
    const isFreeEditService = d.tags && d.tags.includes('Free Edit Service');
    const freeEditServiceBadgeHtml = isFreeEditService? `<div class="image-badge free-edit-service-badge">Free Edit Service</div>`:'';
    const legacyNoteText = bgGetLegacyBadgeText(d);
    const legacyNoteHtml = legacyNoteText ? `<span class="template_access_note">${legacyNoteText}</span>` : '';
	  
	const baseDiscount = extractBaseDiscountFromTags(d.handle || '');
	const { percent: effectiveDiscount, label: memberLabel } = applyMembershipDiscount(baseDiscount);
	const isUnbeatablePrice = hasUnbeatablePriceTag(d.handle || '');
	const badgeText = buildDiscountBadgeText(effectiveDiscount, { memberLabel, unbeatablePrice: isUnbeatablePrice });
	const badgeClass = isUnbeatablePrice
	  ? 'image-badge on-sale-percentage-badge on-sale-percentage-badge--unbeatable'
	  : 'image-badge on-sale-percentage-badge';
	const discountBadgeHtml = badgeText
	  ? `<div class="${badgeClass}">${badgeText}</div>`
	  : '';  
	  
    return `
      <div class="card-wrapper underline-links-hover"
        data-design-number="${getDesignKey(d)}"
        data-id="${d.id||''}"
        data-product="${d.product||''}"
        data-parenturl="${getTemplatePageProductUrlForDesign(d)}"
        data-handle="${d.handle||''}"
        data-template_name="${d.template_name||''}">
        <div class="card card--standard card--media" style="--ratio-percent:76%;">
          <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent:76%;">
            <div class="card__media">
              <div class="media media--transparent">
                ${imagesHtml}
                <div class="image_badge_container">
				${discountBadgeHtml}
                ${newBadgeHtml}
                ${freeEditServiceBadgeHtml}
                </div>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              ${
                include_product_name && d.product
                  ? `<span class="product_name">${d.product}</span>`
                  : ''
              }
              ${
                include_template_name && d.template_name
                  ? `<span class="template_name">"${d.template_name}"</span>`
                  : ''
              }
              ${legacyNoteHtml}
              ${
                include_product_sizes_available && d.sizes_available
                  ? `<span class="size_shape sizes_available">Sizes Available:<br>${(d.sizes_available||[]).join(', ')}</span>`
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // -------------- STATIC ITEM BUTTONS --------------
  function attachStaticItemButtonHandlers() {
    const container = document.getElementById('start-blank-static-item');
    if (!container) return;
    const blankBtn = container.querySelector('.startFromBlankBtn');
    if (blankBtn) {
      blankBtn.addEventListener('click', () => handlePlaceholderLaunch('blank'));
    }
  }

  const BG_CTA_ACTIONS = [
    { type: 'browse', label: 'Browse templates', icon: 'grid', primary: true },
    { type: 'upload', label: 'Upload files', mode: 'uploadfiles', icon: 'upload' },
    { type: 'canva', label: 'Share Canva design', mode: 'uploadcanva', icon: 'link' },
    { type: 'customdesign', label: 'Custom design', mode: 'customdesign', icon: 'spark' },
    { type: 'recreate', label: 'Recreate a design', mode: 'recreate', icon: 'layers' },
    { type: 'uploadlater', label: 'Buy now, design later', mode: 'youhaveart', icon: 'clock' }
  ];

  const BG_CTA_ICONS = {
    grid: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect><rect x="14" y="14" width="7" height="7" rx="1"></rect></svg>',
    upload: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="M12 16V4"></path><path d="m7 9 5-5 5 5"></path><path d="M20 16v4H4v-4"></path></svg>',
    link: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1"></path><path d="M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20.1l1.1-1.1"></path></svg>',
    spark: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="M12 3l1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7L12 3z"></path><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z"></path></svg>',
    layers: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="m12 3 9 5-9 5-9-5 9-5z"></path><path d="m3 12 9 5 9-5"></path><path d="m3 16 9 5 9-5"></path></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>'
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeTextKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function toArrayValue(value) {
    if (Array.isArray(value)) return value;
    if (value == null || value === '') return [];
    return [value];
  }

  function booleanConfig(value, fallback) {
    if (value === true || value === false) return value;
    if (value == null || value === '') return fallback;
    const normalized = String(value).toLowerCase().trim();
    if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
    if (['false', '0', 'no', 'off'].includes(normalized)) return false;
    return fallback;
  }

  function numberConfig(value, fallback = 0) {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : fallback;
  }

  function getProductCatalogMap() {
    return templatePageProductCatalog && typeof templatePageProductCatalog === 'object'
      ? templatePageProductCatalog
      : {};
  }

  function getProductByHandle(handle) {
    const normalized = String(handle || '').toLowerCase().trim();
    if (!normalized) return null;
    const catalog = getProductCatalogMap();
    const product = catalog[normalized];
    if (product && typeof product === 'object') return product;
    return null;
  }

  function getProductName(product) {
    return String(product && (product.productName || product.title || product.handle) || '').trim();
  }

  function getProductUrl(product) {
    const directUrl = String(product && (product.__foundationProductUrl || product.productUrl || product.path) || '').trim();
    if (directUrl) return directUrl;
    const mapping = product && product.editorMapping && typeof product.editorMapping === 'object'
      ? product.editorMapping
      : {};
    const handle = String(
      (mapping && mapping.returnProductHandle)
      || (mapping && mapping.return_product_handle)
      || (product && (product.returnProductHandle || product.return_product_handle))
      || (product && product.handle)
      || ''
    ).trim();
    if (!handle) return '';
    return `/products/${encodeURIComponent(handle)}`;
  }

	  function getTemplatePageProductRecords() {
	    const catalog = templatePageProductCatalog && typeof templatePageProductCatalog === 'object'
	      ? templatePageProductCatalog
	      : {};
	    return Object.values(catalog)
	      .filter(product => product && product.handle)
	      .filter(bgIsVisibleTemplatePageProduct);
  }

  function getTemplatePageTargetProducts() {
    return getTemplatePageProductRecords();
  }

  function getTemplatePageProductUrlForDesign(design) {
    const foundationProductUrl = String(design && design.__foundationProductUrl || '').trim();
    if (foundationProductUrl) return foundationProductUrl;
    const foundationTargetHandle = normalizeProductHandleValue(design && (
      design.__foundationReturnProductHandle
      || design.__foundationTargetProductHandle
      || design.__foundationTargetTemplateSourceHandle
    ));
    if (foundationTargetHandle) {
      const foundationTargetProduct = getProductByHandle(foundationTargetHandle);
      const foundationTargetProductUrl = foundationTargetProduct ? getProductUrl(foundationTargetProduct) : '';
      if (foundationTargetProductUrl) return foundationTargetProductUrl;
    }
    const pageProducts = getTemplatePageTargetProducts();
    if (pageProducts.length === 1) {
      const singleTargetProductUrl = getProductUrl(pageProducts[0]);
      if (singleTargetProductUrl) return singleTargetProductUrl;
    }
    return '';
  }

  window.BGTemplatePageProductUrlResolver = getTemplatePageProductUrlForDesign;

  function resolveTemplateLookupForDesign(design) {
    const direct = String(design && (
      design.templateLookup
      || design.templatePublicId
      || design.template_public_id
      || design.publicId
      || design.public_id
      || design.lookup
    ) || '').trim();
    if (direct) return direct;
    return '';
  }

  function getCurrentTemplateProducts(filteredOverride) {
    const pageProducts = getTemplatePageTargetProducts();
    if (pageProducts.length) return pageProducts;
    return [];
  }

  function getProductArtworkConfig(product) {
    const binding = product && product.designerProductBinding && typeof product.designerProductBinding === 'object'
      ? product.designerProductBinding
      : {};
    const config = product && (product.artworkSection || product.artworkSectionConfig)
      || binding.artworkSection
      || binding.artworkSectionConfig
      || {};
    return {
      binding,
      config,
      modes: new Set(
        toArrayValue(binding.allowedArtworkModes)
          .map(mode => String(mode || '').toLowerCase().replace(/[\s_/-]+/g, ''))
          .filter(Boolean)
      )
    };
  }

  function productSupportsCta(product, type) {
    if (type === 'browse') return true;
    const source = getProductArtworkConfig(product);
    const cfg = source.config || {};
    const modes = source.modes;
    const showNeedDesign = booleanConfig(cfg.showNeedDesign, true);
    const showHaveDesign = booleanConfig(cfg.showHaveDesign, true);
    const showSendLater = booleanConfig(cfg.showSendLater, true);

    if (type === 'upload') {
      return modes.has('uploadfiles') && showHaveDesign && booleanConfig(cfg.showUploadFiles, true);
    }
    if (type === 'canva') {
      return modes.has('uploadcanva') && showHaveDesign && booleanConfig(cfg.showShareCanva, true);
    }
    if (type === 'uploadlater' || type === 'youhaveart') {
      return modes.has('youhaveart') && showSendLater;
    }
    if (type === 'customdesign') {
      return (modes.has('customdesign') || numberConfig(product && product.customDesignCost, 0) > 0)
        && numberConfig(product && product.customDesignCost, 0) > 0
        && showNeedDesign
        && booleanConfig(cfg.showCustomDesign, true);
    }
    if (type === 'recreate') {
      return modes.has('recreate') || modes.has('recreatedesign') || booleanConfig(cfg.showRecreateDesign, false);
    }
    return false;
  }

  function actionProducts(type, filteredOverride) {
    const products = getCurrentTemplateProducts(filteredOverride);
    return products.filter(product => productSupportsCta(product, type));
  }

  function buildArtworkActionUrl(product, type) {
    const action = BG_CTA_ACTIONS.find(entry => entry.type === type);
    const productUrl = getProductUrl(product);
    if (!productUrl || !action || !action.mode) return productUrl;
    return buildUrlWithParams(productUrl, {
      artwork: action.mode,
      [action.mode]: 'true'
    });
  }

  function renderHeroCtaBar(filteredOverride) {
    const heroRoot = document.querySelector('[data-bg-cta-hero]');
    const actionsRoot = document.querySelector('[data-bg-cta-actions]');
    if (!actionsRoot) return;
    const products = getCurrentTemplateProducts(filteredOverride);
    const visibleActions = BG_CTA_ACTIONS.filter(action => {
      if (action.type === 'browse') return true;
      return products.some(product => productSupportsCta(product, action.type));
    });

    if (!products.length && window.allDesignsUngrouped) {
      actionsRoot.innerHTML = '<p class="bg-cta-hero__empty">No matching products were found for these templates.</p>';
      if (heroRoot) heroRoot.hidden = false;
      return;
    }

    actionsRoot.innerHTML = visibleActions.map(action => {
      const icon = BG_CTA_ICONS[action.icon] || '';
      const classes = ['bg-cta-hero__btn'];
      if (action.primary) classes.push('bg-cta-hero__btn--primary');
      return `<button class="${classes.join(' ')}" data-cta-type="${escapeHtml(action.type)}">${icon}<span>${escapeHtml(action.label)}</span></button>`;
    }).join('');
    attachHeroCtaHandlers();
    if (heroRoot) heroRoot.hidden = false;
  }

  // Hero CTA bar handlers for the top quick-start buttons
  function attachHeroCtaHandlers() {
    document.querySelectorAll('.bg-cta-hero__btn').forEach(btn => {
      const type = btn.getAttribute('data-cta-type');
      if (!type || btn.dataset.bgCtaBound === 'true') return;
      btn.dataset.bgCtaBound = 'true';
      btn.addEventListener('click', () => handlePlaceholderLaunch(type));
    });
  }

  function runProductCta(type, product) {
    const redirectUrl = buildArtworkActionUrl(product, type);
    if (!redirectUrl) {
      alert("No product page found for " + getProductName(product) + ".");
      return;
    }

    if (type === 'upload') {
      showUploadFilesConfirm(redirectUrl);
    } else if (type === 'canva') {
      showCanvaConfirm(redirectUrl);
    } else if (type === 'uploadlater' || type === 'youhaveart') {
      showUploadLaterConfirm(redirectUrl);
    } else {
      window.location.href = redirectUrl;
    }
  }

  function handlePlaceholderLaunch(type) {
    if (type === 'browse') {
      const target = document.getElementById('DesignGridContainer') || document.getElementById('design-grid');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    const filtered = getFilteredDesigns();
    if (type === 'blank') {
      const blankProducts = getCurrentTemplateProducts(filtered);
      if (!blankProducts.length) {
        alert("No products found in this collection. Cannot proceed.");
        return;
      }
      if (blankProducts.length === 1) {
        const name = getProductName(blankProducts[0]);
        if (!startFromScratchByProduct[name]) {
          alert("No 'Start from scratch' found for product: " + name);
          return;
        }
        const firstNum = startFromScratchByProduct[name][0];
        showDesign(firstNum, true, false);
      } else {
        openProductChoicePopup(type, blankProducts);
      }
      return;
    }

    const products = actionProducts(type, filtered);
    if (!products.length) {
      alert("This artwork option is not available for the matching products.");
      return;
    }
    if (products.length === 1) {
      runProductCta(type, products[0]);
      return;
    }
    openProductChoicePopup(type, products);
  }
  

	function openMembershipModal () {
	  const modal = document.getElementById('bg-membership-modal');
	  if (!modal) return;
	  modal.style.display = 'flex';
	  document.body.classList.add('modal-open');

	  const closeBtn = modal.querySelector('.membership-close');
	  const outsideClick = e => {
		if (e.target === modal) close();
	  };
	  function close () {
		modal.style.display = 'none';
		document.body.classList.remove('modal-open');
		window.removeEventListener('click', outsideClick);
	  }

	  closeBtn.onclick = close;
  window.addEventListener('click', outsideClick);
}

  function buildUrlWithParams(baseUrl, paramsObj) {
    const entries = Object.entries(paramsObj || {}).filter(([, v]) => v !== undefined && v !== null && v !== '');
    if (!entries.length) return baseUrl;
    const query = entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    return baseUrl + (baseUrl.includes('?') ? '&' : '?') + query;
  }

  function getDesignHandoffId(design) {
    const explicitId = String(design && design.id || '').trim();
    if (explicitId) return explicitId;
    const designNum = String(design && design.designnum || '').trim();
    return designNum ? `designnum:${designNum}` : '';
  }
	
	
  function showCanvaConfirm(redirectUrl) {
  const modal = document.getElementById('bg-canva-modal');
  if (!modal) {
    console.error('bg-canva-modal not found in DOM.');
    return;
  }

  modal.style.display = 'flex'; // show it
  document.body.classList.add('modal-open');

  const closeBtn = modal.querySelector('.canva-close');
  const cancelBtn = modal.querySelector('#canva-cancel');
  const proceedBtn = modal.querySelector('#canva-proceed');

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  // Close on "X" or "Go Back"
  closeBtn.onclick = closeModal;
  cancelBtn.onclick = closeModal;

  // Proceed => redirect
  proceedBtn.onclick = () => {
    const target = buildUrlWithParams(redirectUrl, { uploadcanva: 'true' });
    window.location.href = target;
  };

  // Also close if user clicks outside content
  window.addEventListener('click', function outsideClick(e) {
    if (e.target === modal) {
      closeModal();
      window.removeEventListener('click', outsideClick);
    }
  });
}

  function showYouHaveMyDesignConfirm(redirectUrl) {
  const modal = document.getElementById('bg-you-have-my-design-modal');
  if (!modal) {
    console.error('bg-you-have-my-design-modal not found in DOM.');
    return;
  }

  modal.style.display = 'flex'; // show it
  document.body.classList.add('modal-open');

  const closeBtn = modal.querySelector('.you-have-my-design-close');
  const cancelBtn = modal.querySelector('#you-have-my-design-cancel');
  const proceedBtn = modal.querySelector('#you-have-my-design-proceed');

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  // Close on "X" or "Go Back"
  closeBtn.onclick = closeModal;
  cancelBtn.onclick = closeModal;

  // Proceed => redirect
  proceedBtn.onclick = () => {
    const target = buildUrlWithParams(redirectUrl, { youhaveart: 'true' });
    window.location.href = target;
  };

  // Also close if user clicks outside content
  window.addEventListener('click', function outsideClick(e) {
    if (e.target === modal) {
      closeModal();
      window.removeEventListener('click', outsideClick);
    }
  });
}

  function showUploadLaterConfirm(redirectUrl) {
  const modal = document.getElementById('bg-upload-later-modal');
  if (!modal) {
    console.error('bg-upload-later-modal not found in DOM.');
    return;
  }

  modal.style.display = 'flex'; // show it
  document.body.classList.add('modal-open');

  const closeBtn = modal.querySelector('.upload-later-close');
  const cancelBtn = modal.querySelector('#upload-later-cancel');
  const proceedBtn = modal.querySelector('#upload-later-proceed');

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  // Close on "X" or "Go Back"
  closeBtn.onclick = closeModal;
  cancelBtn.onclick = closeModal;

  // Proceed => redirect
  proceedBtn.onclick = () => {
    const target = buildUrlWithParams(redirectUrl, { uploadlater: 'true' });
    window.location.href = target;
  };

  // Also close if user clicks outside content
  window.addEventListener('click', function outsideClick(e) {
    if (e.target === modal) {
      closeModal();
      window.removeEventListener('click', outsideClick);
    }
  });
}  
  
function showUploadFilesConfirm(redirectUrl) {
  const modal = document.getElementById('bg-upload-files-modal');
  if (!modal) {
    console.error('bg-upload-files-modal not found in DOM.');
    return;
  }

  modal.style.display = 'flex'; // show it
  document.body.classList.add('modal-open');

  const closeBtn = modal.querySelector('.upload-files-close');
  const cancelBtn = modal.querySelector('#upload-files-cancel');
  const proceedBtn = modal.querySelector('#upload-files-proceed');

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  // Close on "X" or "Go Back"
  closeBtn.onclick = closeModal;
  cancelBtn.onclick = closeModal;

  // Proceed => redirect
  proceedBtn.onclick = () => {
    const target = buildUrlWithParams(redirectUrl, { uploadFiles: 'true' });
    window.location.href = target;
  };

  // Also close if user clicks outside content
  window.addEventListener('click', function outsideClick(e) {
    if (e.target === modal) {
      closeModal();
      window.removeEventListener('click', outsideClick);
    }
  });
}  	
	
	
	
  function openProductChoicePopup(type, productArr) {
    const popup = document.getElementById('bg-product-popup');
    const popupList = document.getElementById('bg-product-popup-list');
    popupList.innerHTML='';
    const products = (productArr || []).map(entry => {
      if (entry && typeof entry === 'object') return entry;
      const label = String(entry || '').trim();
      const catalogProduct = Object.values(getProductCatalogMap()).find(product => getProductName(product) === label);
      return catalogProduct || { handle: '', productName: label };
    }).filter(product => product && getProductName(product));

    // gather one example design per product (for images)
    const filtered = getFilteredDesigns();
    const productMap = {};
    filtered.forEach(d => {
      const p = (d.product||'').trim();
      if (!p) return;
      if (!productMap[p]) {
        productMap[p] = d;
      }
    });

    products.forEach(product => {
      const prod = getProductName(product);
      const d = productMap[prod];
      const imageURL = bgResolveProductImageUrl(product, d, 360);
      const productHandle = String(product && product.handle || '').toLowerCase().trim();
      const li=document.createElement('li');
      const a = document.createElement('a');
      a.href='#';
      a.innerHTML=`
        <img src="${escapeHtml(imageURL)}" alt="${escapeHtml(prod)}" data-bg-product-image="${escapeHtml(productHandle)}" data-bg-product-image-width="360"/>
        <span>${escapeHtml(prod)}</span>
      `;
      a.addEventListener('click', e=>{
        e.preventDefault();
        popup.style.display='none';
        document.body.classList.remove('modal-open');
        if (type !== 'blank') {
          runProductCta(type, product);
          return;
        }
          if (!startFromScratchByProduct[prod]) {
            alert("No 'Start from scratch' found for product: "+prod);
            return;
          }
          const num = startFromScratchByProduct[prod][0];
          showDesign(num, true, false);
      });
      li.appendChild(a);
      popupList.appendChild(li);
    });

    popup.style.display='flex';
    document.body.classList.add('modal-open');
    document.querySelector('.bg-product-popup-close').onclick=()=>{
      popup.style.display='none';
      document.body.classList.remove('modal-open');
    };
    window.addEventListener('click', ev=>{
      if(ev.target===popup){
        popup.style.display='none';
        document.body.classList.remove('modal-open');
      }
    });
  }

function initStackedPreviewToggles(root) {
  // root can be the whole grid or a single <li>
  const containers = (root instanceof Element)
    ? root.querySelectorAll('.bc-stacked-preview')
    : document.querySelectorAll('.bc-stacked-preview');

  containers.forEach(container => {
    const frontBtn = container.querySelector('.bc-toggle--front');
    const backBtn  = container.querySelector('.bc-toggle--back');
    if (!frontBtn || !backBtn) return;

    const setView = (view) => {
      const showBack = (view === 'back');
      container.classList.toggle('back-on-top', showBack);
      frontBtn.classList.toggle('active', !showBack);
      backBtn.classList.toggle('active',  showBack);
      frontBtn.setAttribute('aria-pressed', String(!showBack));
      backBtn.setAttribute('aria-pressed',  String(showBack));
    };

    const handler = (view) => (e) => {
      e.preventDefault();
      e.stopPropagation();   // avoid bubbling into the card click (modal)
      setView(view);
    };

    frontBtn.addEventListener('click', handler('front'));
    backBtn.addEventListener('click',  handler('back'));

    // Optional: left/right arrows toggle as well
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        setView(container.classList.contains('back-on-top') ? 'front' : 'back');
      }
    });
  });
}


  /* =============== GRID ITEMS (REGULAR DESIGNS) =============== */
  function attachEventListenersToGridItems() {
    const desktopModal = document.getElementById('design-modal-desktop');
    const mobileModal  = document.getElementById('design-modal-mobile');
    const closeDesktopBtn = desktopModal.querySelector('.modal-header .close');
    const closeMobileBtn  = mobileModal.querySelector('.modal-header .close');

    document.querySelectorAll('.bg_design_grid_item').forEach(item => {
      if (item.id==='start-blank-static-item') return;
      if (item.classList.contains('needACustomDesign')) return;

      item.addEventListener('click', e => {
        e.preventDefault();
        const cw = item.querySelector('.card-wrapper');
        if (!cw) return;
        const designNum = (cw.dataset.designNumber || '').trim();
        if (!designNum) return;
        showDesign(designNum);
      });
    });

    closeDesktopBtn.addEventListener('click', () => closeModal(desktopModal));
    closeMobileBtn.addEventListener('click', () => closeModal(mobileModal));

    window.addEventListener('click', ev => {
      if (ev.target===desktopModal) closeModal(desktopModal);
      if (ev.target===mobileModal)  closeModal(mobileModal);
    });
  }

function preloadGroupImages(numArray) {
    numArray.forEach(n => {
      const dObj = designByNumber[n];
      if (dObj && dObj.previews && Array.isArray(dObj.previews)) {
        dObj.previews.forEach(url => {
          if (url) {
            const img = new Image();
            img.src = url; 
          }
        });
      }
    });
  }
	
	
function syncURLWithState() {
  try {
    const url = new URL(window.location.href);
    const p   = new URLSearchParams('');

    // Collect all selected values per filter group
    const FIELD_IDS = [
      'product','category','industry','shape','size','direct_mail','occasion','use_case',
      'printed_sides','fold','type','print_colors','equipment','material','editability',
      'orientation','color','corners','style','perforation','styles_themes'
    ];

    FIELD_IDS.forEach(f => {
      const vals = Array.from(document.querySelectorAll(`#${f}-filter input[type="checkbox"]:checked`))
        .map(cb => cb.value)
        .filter(Boolean);
      if (vals.length) {
        // Join multiples with commas so a single key carries many selections
        // (we also support repeated keys on read)
        p.set(f, vals.join(','));
      }
    });

    // Product selection lives in the swatch row, not a checkbox group.
    // Write the handle: it is comma-free and round-trips through the
    // comma-splitting URL reader (product names may not).
    const swatchProduct = bgGetSelectedSwatchProduct();
    if (swatchProduct) {
      p.set('product', String(swatchProduct.handle || getProductName(swatchProduct)).toLowerCase().trim());
    }

    // Sort
    const sel = document.getElementById('sort-select');
    if (sel) {
      const val = sel.value; // default | random | newest | most_popular
      const backMap = { 'default':'default', 'random':'random', 'newest':'new', 'most_popular':'popular' };
      p.set('sort', backMap[val] || 'default');
    }

    const q = (document.getElementById('search-input')?.value || '').trim();
    if (q) p.set('q', q);

    const newQS = p.toString();
    const next  = `${url.pathname}${newQS ? ('?' + newQS) : ''}${url.hash || ''}`;
    window.history.replaceState({}, '', next);
  } catch (e) {
    console.warn('[URLSync] Failed to sync URL', e);
  }
}



// ==== BACKERS (Option 1 simple) =================================
function renderBackersUI({ activeModal, designObj, imagesContainer, initPreviewFn }) {
  const backers = Array.isArray(designObj.backers) ? designObj.backers : [];
  const section = activeModal.querySelector('.backer-section');
  const pillsEl = activeModal.querySelector('.backer-pills');
  const thumbsEl = activeModal.querySelector('.backer-thumbs');

  // Hide if not applicable
  if (!backers.length) {
    if (section) {
      section.style.display = 'none';
      // If the design has number_of_pages==1 or use_backer_swatches not used:
      // show simple note only if you want — leaving hidden is fine.
    }
    return;
  }

  // Show section
  section.style.display = 'block';
  pillsEl.innerHTML = '';
  thumbsEl.innerHTML = '';

  // Which backer is active on open?
  const urlBacker = new URL(location.href).searchParams.get('backer');
  const defaultId = (designObj.default_backer_id || '').toString();
  let currentId = urlBacker && backers.some(b => (b.id || '').toLowerCase() === urlBacker.toLowerCase())
    ? urlBacker
    : (defaultId || backers[0].id);

  // Render pills
  backers.forEach(b => {
    const pill = document.createElement('div');
    pill.className = 'backer-pill';
    pill.textContent = b.label || b.id;
    if ((b.id || '').toLowerCase() === currentId.toLowerCase()) pill.classList.add('active');
    pill.addEventListener('click', () => selectBacker(b.id));
    pillsEl.appendChild(pill);
  });

  // Render thumbs
backers.forEach(b => {
  const box = document.createElement('div');
  box.className = 'backer-thumb';
  box.dataset.backerId = b.id;
  box.setAttribute('role', 'button');
  box.setAttribute('tabindex', '0');
  box.setAttribute('aria-pressed', 'false');
  if ((b.id || '').toLowerCase() === currentId.toLowerCase()) {
    box.classList.add('selected');
    box.setAttribute('aria-pressed','true');
  }

  const imgWrap = document.createElement('div');
  imgWrap.className = 'backer-thumb-img';

  const img = document.createElement('img');
  img.loading = 'lazy';
  img.alt = (b.label || b.id) + ' backer';
  img.src = b.thumb || (Array.isArray(b.previews) ? (b.previews[1] || b.previews[0] || '') : '');
  imgWrap.appendChild(img);

  const label = document.createElement('div');
  label.className = 'backer-thumb-label';
  label.textContent = b.label || b.id;

  box.appendChild(imgWrap);
  box.appendChild(label);

  const activate = () => selectBacker(b.id);
  box.addEventListener('click', activate);
  box.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      activate();
    }
  });

  thumbsEl.appendChild(box);
});


  // Apply the initial selection (swap preview once)
  const initial = backers.find(x => (x.id || '').toLowerCase() === currentId.toLowerCase());
  if (initial && Array.isArray(initial.previews) && initial.previews.length) {
    initPreviewFn(initial.previews);
  }

  function selectBacker(id) {
    currentId = id;

    // UI states
    pillsEl.querySelectorAll('.backer-pill').forEach(el => el.classList.remove('active'));

    // UI states (only tiles are visible/interactive)
thumbsEl.querySelectorAll('.backer-thumb').forEach(el => {
  const isMe = (el.dataset.backerId || '').toLowerCase() === id.toLowerCase();
  el.classList.toggle('selected', isMe);
  el.setAttribute('aria-pressed', String(isMe));
});

    const pill = Array.from(pillsEl.children).find(el => (el.textContent || '').trim().toLowerCase() === ((backers.find(b => b.id === id)?.label || id).toLowerCase()));
    const thumb = Array.from(thumbsEl.children).find(el => (el.dataset.backerId || '').toLowerCase() === id.toLowerCase());
    if (pill) pill.classList.add('active');
    if (thumb) thumb.classList.add('selected');


// Preview swap
const obj = backers.find(b => (b.id || '').toLowerCase() === id.toLowerCase());
const previewsArr = Array.isArray(obj?.previews) && obj.previews.length ? obj.previews : (designObj.previews || []);
initPreviewFn(previewsArr, true);


    // Update CTAs to include &backer=
    updateBackerParamOnCTAs(activeModal, id);
  }
}

// Add &backer=<id> to Customize/Edit-Service links in the open modal
function updateBackerParamOnCTAs(activeModal, backerId) {
  if (!backerId) return;
  activeModal.dataset.selectedBacker = backerId;
  const editLink = activeModal.querySelector('.modal-editservice-button');
  if (editLink && editLink.href) {
    try {
      const u = new URL(editLink.href, window.location.origin);
      u.searchParams.set('backer', backerId);
      editLink.href = u.toString();
    } catch (_) {
      editLink.href = buildUrlWithParams(editLink.href, { backer: backerId });
    }
  }
}

function normalizeDesignPrintingValue(value) {
  const normalized = String(value || '')
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (/^(?:print\s+)?(?:1|one)\s+colou?r(?:\b|$)/.test(normalized)) return '1 Color';
  // Keep the current concatenated legacy import tag compatible while also
  // accepting the corrected "Full Color" value.
  if (/^(?:print\s+)?full\s+colou?r/.test(normalized)) return 'Full Color';
  return '';
}

function getDesignPrintingValue(design) {
  const tags = Array.isArray(design && design.tags)
    ? design.tags
    : String(design && design.tags || '').split(',');
  for (const tag of tags) {
    const printing = normalizeDesignPrintingValue(tag);
    if (printing) return printing;
  }
  return '';
}

function getDesignPrintingTargetingID(design) {
  const printing = getDesignPrintingValue(design);
  if (printing === '1 Color') return 'print-1-color';
  if (printing === 'Full Color') return 'print-full-color';
  return '';
}

function getDesignAttributeValue(design, attributeName) {
  if (attributeName === 'printing') return getDesignPrintingValue(design);
  const value = design && design[attributeName];
  return value == null ? '' : String(value).trim();
}

function appendDesignPrintingParam(url, design) {
  const printingTargetingID = getDesignPrintingTargetingID(design);
  return printingTargetingID
    ? buildUrlWithParams(url, { Printing: printingTargetingID })
    : url;
}



  /* =============== SHOW DESIGN (MODAL) =============== 
     showDesign(designNum, doSizePreselection=false, canvaMode=false)
  */
function showDesign(designNum, doSizePreselection = false, canvaMode = false, uploadLaterMode = false, youHaveMyDesignMode = false) {
  ///////////////////////////////////////////////////////////////////
  // 1) Setup multi-attribute fields we want pills for
  ///////////////////////////////////////////////////////////////////
  // - We ALWAYS show Printing and Size, even if only 1 value. For orientation, etc., we only show if 2+ values.
  // If you want to add more attributes like 'perforation', just add it to this array.
  const attributeOrder = ['printing', 'shape', 'size', 'orientation'];
  
  const attributeLabels = {
    printing: 'Printing',
	shape: 'Shape',  
    size: 'Size',
    orientation: 'Orientation'    
  };

  ///////////////////////////////////////////////////////////////////
  // 2) Helper function: build pills for a single attribute
  ///////////////////////////////////////////////////////////////////
function buildAttributePills(attributeName, subsetOfDesigns, currentDesignNum, containerEl) {
  // Keep subsequent attribute choices compatible with the active Printing
  // mode. Printing itself must continue to see the full linked-design group.
  if (attributeName !== 'printing') {
    const printingRow = containerEl.querySelector('.printing-pills-container');
    const activePrintingPill = printingRow && printingRow.querySelector('.printing-pill.active');
    if (activePrintingPill) {
      const chosenPrinting = (activePrintingPill.dataset.value || activePrintingPill.textContent).trim();
      subsetOfDesigns = subsetOfDesigns.filter(function(num) {
        return getDesignAttributeValue(designByNumber[num], 'printing') === chosenPrinting;
      });
    }
  }

  // If this is orientation, and the user already picked a size,
  // refine the subset to only those designs matching the active size.
  if (attributeName === 'orientation') {
    var sizeRow = containerEl.querySelector('.size-pills-container');
    if (sizeRow) {
      var activeSizePill = sizeRow.querySelector('.size-pill.active');
      if (activeSizePill) {
        // ⬇️ IMPORTANT: use the underlying value, not the displayed label
        var chosenSize = (activeSizePill.dataset.value || activeSizePill.textContent).trim();
        subsetOfDesigns = subsetOfDesigns.filter(function(num) {
          var dObj = designByNumber[num];
          return dObj && dObj.size && dObj.size.trim() === chosenSize;
        });
      }
    }
  }

  // If we are building the SIZE pills and user has chosen a Shape,
  // refine to only designs matching the chosen shape.
  if (attributeName === 'size') {
    const shapeRow = containerEl.querySelector('.shape-pills-container');
    if (shapeRow) {
      const activeShapePill = shapeRow.querySelector('.shape-pill.active');
      if (activeShapePill) {
        const chosenShape = activeShapePill.textContent.trim();
        subsetOfDesigns = subsetOfDesigns.filter(function(num) {
          const dObj = designByNumber[num];
          return dObj && dObj.shape && dObj.shape.trim() === chosenShape;
        });
      }
    }
  }

  // 2A) Collect distinct values for this attribute.
  // For SIZE, we build a map of actual size -> displayed label (size_display_as if present).
  let valuesSet = new Set();
  let sizeDisplayMap = null;

  if (attributeName === 'size') {
    sizeDisplayMap = new Map();
    subsetOfDesigns.forEach(function(num) {
      const dObj = designByNumber[num];
      if (!dObj || !dObj.size) return;
      const raw = dObj.size.trim();
      if (!raw) return;
      // prefer size_display_as when present
      const sda = (dObj.size_display_as || '').toString().trim();
      const display = sda || raw;
      if (!sizeDisplayMap.has(raw)) sizeDisplayMap.set(raw, display);
      valuesSet.add(raw); // keep the underlying canonical size value
    });
  } else {
    subsetOfDesigns.forEach(function(num) {
      var dObj = designByNumber[num];
      var val = getDesignAttributeValue(dObj, attributeName);
      if (val) valuesSet.add(val);
    });
  }

  // 2B) If there are ZERO possible values, skip building pills entirely
  if (valuesSet.size === 0) return;

  // 2C) Printing and Size stay visible with one value; other single-value
  // attributes do not need a choice row.
  if (attributeName !== 'printing' && attributeName !== 'size' && valuesSet.size <= 1) return;

  // Insert heading
  var heading = document.createElement('h4');
  heading.className = 'pills-header';
  heading.textContent = attributeLabels[attributeName]
    || (attributeName.charAt(0).toUpperCase() + attributeName.slice(1));
  containerEl.appendChild(heading);

  // Container for pills
  var pillRow = document.createElement('div');
  pillRow.className = attributeName + '-pills-container pills-container';
  containerEl.appendChild(pillRow);

  // Sort values
var sortedVals = Array.from(valuesSet).sort(function(a, b) {
  if (attributeName === 'size' && sizeDisplayMap) {
    // Use the displayed label (size_display_as when present)
    const dispA = sizeDisplayMap.get(a) || a;
    const dispB = sizeDisplayMap.get(b) || b;

    // Normalize to the leading word(s) before the "(" for matching:
    // e.g. "Standard (2\" x 3.5\")" -> "standard"
    const baseA = (dispA.split('(')[0] || dispA).trim().toLowerCase();
    const baseB = (dispB.split('(')[0] || dispB).trim().toLowerCase();

    const rankA = Object.prototype.hasOwnProperty.call(SIZE_LABEL_PRIORITY, baseA)
      ? SIZE_LABEL_PRIORITY[baseA]
      : Number.POSITIVE_INFINITY;
    const rankB = Object.prototype.hasOwnProperty.call(SIZE_LABEL_PRIORITY, baseB)
      ? SIZE_LABEL_PRIORITY[baseB]
      : Number.POSITIVE_INFINITY;

    if (rankA !== rankB) return rankA - rankB;

    // Same rank (or both unranked) — fall back to your physical dimension sort:
    const dimA = parsePhysicalDimension(a);
    const dimB = parsePhysicalDimension(b);
    if (dimA && dimB) {
      if (dimA[0] !== dimB[0]) return dimA[0] - dimB[0];
      return dimA[1] - dimB[1];
    }

    // Finally, alpha fallback
    return a.localeCompare(b);
  }

  // Non-size attributes keep default alpha
  return a.localeCompare(b);
});


  // Build each pill
  sortedVals.forEach(function(val) {
    if (!val.trim()) return;

    // Display label: for size use size_display_as if captured; else raw val
    const displayLabel = (attributeName === 'size' && sizeDisplayMap)
      ? (sizeDisplayMap.get(val) || val)
      : val;

    var pill = document.createElement('div');
    pill.className = attributeName + '-pill pill';
    pill.textContent = displayLabel;

    // ⬇️ Carry the real underlying value for comparisons & URL preselects
    pill.dataset.value = val;

    // Active state uses the real attribute value
    var curObj = designByNumber[currentDesignNum];
    var curVal = getDesignAttributeValue(curObj, attributeName);
    if (val === curVal) {
      pill.classList.add('active');
    }

    // On click, choose by underlying value (dataset.value), not by label
    pill.onclick = function() {
      // Deactivate siblings
      pillRow.querySelectorAll('.' + attributeName + '-pill').forEach(function(x) {
        x.classList.remove('active');
      });
      pill.classList.add('active');

      // Gather all chosen attribute values (prefer dataset.value)
      var chosen = {};
      ['printing', 'shape', 'size', 'orientation'].forEach(function(attr) {
        var row = containerEl.querySelector('.' + attr + '-pills-container');
        if (!row) return;
        var activePill = row.querySelector('.' + attr + '-pill.active');
        if (activePill) {
          chosen[attr] = (activePill.dataset.value || activePill.textContent).trim();
        }
      });

      // Find design that matches all chosen attrs
      var found = subsetOfDesigns.find(function(n) {
        var o = designByNumber[n];
        if (!o) return false;
        return Object.entries(chosen).every(function(pair) {
          var k = pair[0], v = pair[1];
          return getDesignAttributeValue(o, k) === v;
        });
      });

      if (found) {
        showDesign(found, false, false);
      } else {
        // If SIZE changed and incompatible orientation was selected, clear orientation and retry
        if (attributeName === 'size' && chosen.orientation) {
          delete chosen.orientation;
          var orientationRow = containerEl.querySelector('.orientation-pills-container');
          if (orientationRow) {
            orientationRow.querySelectorAll('.orientation-pill').forEach(function(p) {
              p.classList.remove('active');
            });
          }
          var found2 = subsetOfDesigns.find(function(n) {
            var o = designByNumber[n];
            if (!o) return false;
            return Object.entries(chosen).every(function(pair) {
              var k = pair[0], v = pair[1];
              return getDesignAttributeValue(o, k) === v;
            });
          });
          if (found2) {
            showDesign(found2, false, false);
            return;
          }
        }

        // If SHAPE changed and incompatible SIZE/ORIENTATION selected, clear and retry
        if (attributeName === 'shape' && (chosen.size || chosen.orientation)) {
          delete chosen.size;
          delete chosen.orientation;
          var sizeRow2 = containerEl.querySelector('.size-pills-container');
          if (sizeRow2) sizeRow2.querySelectorAll('.size-pill').forEach(p => p.classList.remove('active'));
          var orientationRow2 = containerEl.querySelector('.orientation-pills-container');
          if (orientationRow2) orientationRow2.querySelectorAll('.orientation-pill').forEach(p => p.classList.remove('active'));
          var found3 = subsetOfDesigns.find(function(n) {
            var o = designByNumber[n];
            if (!o) return false;
            return Object.entries(chosen).every(function(pair) {
              var k = pair[0], v = pair[1];
              return getDesignAttributeValue(o, k) === v;
            });
          });
          if (found3) {
            showDesign(found3, false, false);
            return;
          }
        }

        // If the opposite print mode does not have the same secondary
        // attributes, switch to its first linked design instead of leaving a
        // visibly active pill that did not change the design.
        if (attributeName === 'printing' && chosen.printing) {
          var foundPrinting = subsetOfDesigns.find(function(n) {
            return getDesignAttributeValue(designByNumber[n], 'printing') === chosen.printing;
          });
          if (foundPrinting) {
            showDesign(foundPrinting, false, false);
            return;
          }
        }

        alert('No matching design found for ' + JSON.stringify(chosen));
      }
    };

    pillRow.appendChild(pill);
  });
}



  ///////////////////////////////////////////////////////////////////
  // 3) Lookup the current design
  ///////////////////////////////////////////////////////////////////
  const designObj = designByNumber[designNum];
  if (!designObj) {
    console.warn("No design found for #", designNum);
    return;
  }

  // Decide which modal is active (desktop or mobile)
  const isDesktop = (window.innerWidth >= 768);
  const desktopModal        = document.getElementById('design-modal-desktop');
  const mobileModal         = document.getElementById('design-modal-mobile');
  const desktopImages       = desktopModal.querySelector('.modal-images-desktop');
  const desktopSaleBanner   = desktopModal.querySelector('.sale-banner');
  const desktopTagBadges    = desktopModal.querySelector('.desktop-tag-badges-container');
  const desktopProductPills = desktopModal.querySelector('.desktop-product-pills');
  const desktopPills        = desktopModal.querySelector('.desktop-pills');
  const desktopPricing      = desktopModal.querySelector('.desktop-pricing-table');
  const desktopCustomize    = desktopModal.querySelector('.desktop-customize');
  const mobileImages        = mobileModal.querySelector('.mobile-images-container');
  const mobileToggle        = mobileModal.querySelector('.mobile-image-toggle');
  const mobileSaleBanner    = mobileModal.querySelector('.sale-banner');
  const mobileTagBadges     = mobileModal.querySelector('.mobile-tag-badges-container');
  const mobileProductPills  = mobileModal.querySelector('.mobile-product-pills');
  const mobilePills         = mobileModal.querySelector('.mobile-pills');
  const mobilePricing       = mobileModal.querySelector('.mobile-pricing-table');
  const mobileCustomize     = mobileModal.querySelector('.mobile-customize');

  let activeModal, imagesContainer, saleBannerEl, tagBadges, productPillContainer,
      oldSizePillContainer, pricingTableEl, customizeContainer, toggleEl;

  if (isDesktop) {
    activeModal         = desktopModal;
    imagesContainer     = desktopImages;
    saleBannerEl        = desktopSaleBanner;
    tagBadges           = desktopTagBadges;
    productPillContainer= desktopProductPills;
    oldSizePillContainer= desktopPills;
    pricingTableEl      = desktopPricing;
    customizeContainer  = desktopCustomize;
    toggleEl            = null;
  } else {
    activeModal         = mobileModal;
    imagesContainer     = mobileImages;
    saleBannerEl        = mobileSaleBanner;
    tagBadges           = mobileTagBadges;
    productPillContainer= mobileProductPills;
    oldSizePillContainer= mobilePills;
    pricingTableEl      = mobilePricing;
    customizeContainer  = mobileCustomize;
    toggleEl            = mobileToggle;
  }

  ///////////////////////////////////////////////////////////////////
  // 4) Clear old content
  ///////////////////////////////////////////////////////////////////
  imagesContainer.innerHTML = '';
  imagesContainer.classList.remove('single-image-desktop','side-by-side','stacked');
  if (toggleEl) toggleEl.style.display='none';
  saleBannerEl.style.display='none';
  tagBadges.innerHTML = '';
  productPillContainer.innerHTML = '';
  oldSizePillContainer.innerHTML = '';
  pricingTableEl.innerHTML = '';
  customizeContainer.innerHTML = '';

  // Remove any leftover .attributes-container
  const oldAttrs = activeModal.querySelector('.attributes-container');
  if (oldAttrs) oldAttrs.remove();


  // ---- Placeholder logic (must be defined BEFORE initPreviewFn uses it) ----
const nameLower = (designObj.template_name || '').toLowerCase().trim();
const isPlaceholder = (nameLower === 'upload completed design' || nameLower === 'start from scratch');



const suiteKey = (designObj.design_suite ?? '').toString().trim();
let groupNums;

if (
  suiteKey &&
  window.designSuiteIndex &&
  Array.isArray(window.designSuiteIndex[suiteKey]) &&
  window.designSuiteIndex[suiteKey].length
) {
  groupNums = Array.from(
    new Set(window.designSuiteIndex[suiteKey].concat([designNum]))
  ).filter(n => designByNumber[n]);
} else {
  const linkedStr = (designObj['linked designs string'] || '').trim();
  if (linkedStr) {
    const linkedNums = linkedStr
      .split(',')
      .map(x => parseInt(x.trim(), 10))
      .filter(x => designByNumber[x]);
    groupNums = Array.from(new Set([designNum, ...linkedNums])).filter(x => designByNumber[x]);
  } else {
    groupNums = [designNum];
  }
}

// Drop siblings that resolve to excluded products (testing/unpublished) so
// suite/linked pills never surface a product the page has hidden.
groupNums = groupNums.filter(n => {
  const d = designByNumber[n];
  return d && !shouldExcludeDesign(d);
});
if (!groupNums.length) groupNums = [designNum];

  preloadGroupImages(groupNums);
  // Build a dictionary product -> array of designNums
  const productMap = {};
  groupNums.forEach(n => {
    const d = designByNumber[n];
    if (!d) return;
    const p = d.product || 'Unknown Product';
    if (!productMap[p]) productMap[p] = [];
    productMap[p].push(n);
  });
  // Sort by size, if needed
  Object.keys(productMap).forEach(prod => {
    productMap[prod].sort((a,b) => {
      const A = designByNumber[a], B = designByNumber[b];
      return customSizeShapeSort(A.size || '', B.size || '');
    });
  });

  const currentProduct = designObj.product || 'Unknown Product';

  ///////////////////////////////////////////////////////////////////
  // 6) Build product pills
  ///////////////////////////////////////////////////////////////////
  Object.keys(productMap).forEach(prod => {
    const pill = document.createElement('div');
    pill.className = 'product-pill';
    pill.textContent = prod;
    if (prod === currentProduct) {
      pill.classList.add('active');
    }
    pill.onclick = () => {
      const firstNum = productMap[prod][0];
      showDesign(firstNum, doSizePreselection, canvaMode);
    };
    productPillContainer.appendChild(pill);
  });

  ///////////////////////////////////////////////////////////////////
  // 7) subsetOfDesigns for the current product
  ///////////////////////////////////////////////////////////////////
  const subsetOfDesigns = productMap[currentProduct] || [];

  ///////////////////////////////////////////////////////////////////
  // 8) Build multi-attribute pills (size + orientation, etc.)
  ///////////////////////////////////////////////////////////////////
  const attributesContainer = document.createElement('div');
  attributesContainer.className = 'attributes-container';
  productPillContainer.insertAdjacentElement('afterend', attributesContainer);

  attributeOrder.forEach(attr => {
    buildAttributePills(attr, subsetOfDesigns, designNum, attributesContainer);
  });



// ==== BACKERS: init + preview swap hook =======================
const initPreviewFn = (previewsArr, wantBack = false) => {
  const ps = designObj.preview_settings || {};
  const targetAR = getDesignAspectRatio(designObj);

  if (!isPlaceholder) {
    BG3DPreview.init(imagesContainer, previewsArr, {
      enable      : ps.enable_3d === true,
      autoRotate  : ps.auto_rotate === true,
      // On user backer change we don’t want wobble — only on initial show
      wobble      : wantBack ? false : (ps.wobble === true),
      rotateSpeed : ps.rotate_speed || 18,
      finish      : ps.surface_finish || 'matte',
      depth       : ps.depth_px ?? 2,
      edgeColor   : ps.edge_color || '#fafafa',
      // Start on Back (180°) when a backer is chosen by the user
      initialAngle: wantBack ? 180 : (ps.initial_angle || 0),
      targetAR
    });
  } else {
    // Flat/stacked preview fallback
    imagesContainer.innerHTML = `<div class="bg-flat-preview"><img src="${(previewsArr[0]||'')}" alt=""></div>`;
  }

  // If this design renders a stacked (flat) preview, force Back on top when wantBack=true
  if (wantBack) {
    requestAnimationFrame(() => {
      const c = imagesContainer.querySelector('.bc-stacked-preview');
      if (c) {
        c.classList.add('back-on-top');
        const f = c.querySelector('.bc-toggle--front');
        const b = c.querySelector('.bc-toggle--back');
        if (f && b) {
          f.classList.remove('active'); f.setAttribute('aria-pressed','false');
          b.classList.add('active');    b.setAttribute('aria-pressed','true');
        }
      }
    });
  }
};


// Renders pills + thumbs and (if any) swaps to initial backer previews
renderBackersUI({
  activeModal,
  designObj,
  imagesContainer,
  initPreviewFn
});



  ///////////////////////////////////////////////////////////////////
  // 9) Preselection from URL
  ///////////////////////////////////////////////////////////////////
  if (doSizePreselection) {
    const url = new URL(window.location.href);
    attributeOrder.forEach(attr => {
      const paramVal = url.searchParams.get(attr === 'printing' ? 'Printing' : attr);
      if (!paramVal) return;
      const row = attributesContainer.querySelector(`.${attr}-pills-container`);
      if (!row) return;
      row.querySelectorAll(`.${attr}-pill`).forEach(p => {
        const target = attr === 'printing'
          ? normalizeDesignPrintingValue(paramVal).toLowerCase()
          : paramVal.toLowerCase();
        const label  = p.textContent.trim().toLowerCase();
        const value  = (p.dataset.value || '').toLowerCase(); // works for size
        if (label === target || value === target) {
          p.click();
        }
      });
    });
  }



  ///////////////////////////////////////////////////////////////////
  // 11) Sale banner / discount logic
  ///////////////////////////////////////////////////////////////////
const handle = designObj.handle || '';
const baseDiscount = extractBaseDiscountFromTags(handle);
const { percent: discountPercentage } = applyMembershipDiscount(baseDiscount);

// remove stale badge if re-rendering
const oldModalBadge = activeModal.querySelector('.productDiscountBadge');
if (oldModalBadge) oldModalBadge.remove();

const badgeText = buildShownSaleBadgeText(handle);
const isUnbeatableBadge = badgeText === UNBEATABLE_PRICE_BADGE;

if (badgeText) {
  // saleBannerEl.style.display = 'block';
  const badgeClass = `productDiscountValue2 productDiscountBadge${isUnbeatableBadge ? ' productDiscountBadge--unbeatable' : ''}`;
  const badgeHTML = `
    <div class="${badgeClass}" style="margin-top:4px;">
      ${badgeText}
    </div>`;

  // insert right below the ON SALE banner
  saleBannerEl.insertAdjacentHTML('afterend', badgeHTML);
}	




  
  ///////////////////////////////////////////////////////////////////
  // 12) Pricing table
  ///////////////////////////////////////////////////////////////////
  renderReferencePriceTable(pricingTableEl, designObj, discountPercentage, readTierSalePercent(handle));
	
	
// The pricing renderer preserves the authored disclaimer after async reads.
	

///////////////////////////////////////////////////////////////////////
// 13) Final link for placeholders vs. normal
///////////////////////////////////////////////////////////////////////
const productUrl = getTemplatePageProductUrlForDesign(designObj);
function buildProductLaunchUrl() {
  const params = { from: 'templates' };
  if (designObj.id) params.id = designObj.id;
  if (designObj.designnum) params.designnum = designObj.designnum;
  const templateLookup = resolveTemplateLookupForDesign(designObj);
  if (templateLookup) params.templateLookup = templateLookup;
  if (canvaMode) params.uploadcanva = 'true';
  if (uploadLaterMode) params.uploadlater = 'true';
  if (youHaveMyDesignMode) params.youhaveart = 'true';
  if (!isPlaceholder && !canvaMode && !uploadLaterMode && !youHaveMyDesignMode) {
    params.artwork = 'designonline';
    params.designonline = 'true';
    params.bg_template_action = 'customize_online';
  }

  let url = buildUrlWithParams(productUrl, params);
  url = appendTargetingIDs(url, designObj);
  url = appendDesignPrintingParam(url, designObj);

  const selectedThumb = activeModal.querySelector('.backer-thumb.selected');
  let backerId = selectedThumb?.dataset?.backerId;
  if (!backerId && activeModal.dataset.selectedBacker) {
    backerId = activeModal.dataset.selectedBacker;
  }
  if (backerId) {
    url = buildUrlWithParams(url, { backer: backerId });
  }
  return url;
}



if (isPlaceholder) {
  activeModal.classList.add('placeholder-modal');
} else {
  activeModal.classList.remove('placeholder-modal');
}

const btn = document.createElement('a');
const availability = bgGetDesignAvailability(designObj);
const canCustomizeOnline = availability.isOnline && !!designObj.id;
const canEditService = availability.canEdit && productUrl !== '#' && (designObj.id || designObj.designnum);
const legacyNote = availability.isLegacy ? bgGetLegacyNote(designObj) : '';
btn.href = productUrl;
btn.className = 'modal-customize-button';
btn.addEventListener('click', function(e) {
  e.preventDefault();
  window.location.href = buildProductLaunchUrl();
});

if (isPlaceholder) {
  btn.textContent = 'Proceed to designer';
  customizeContainer.appendChild(btn);
} else {
  // optional edit-service link
 
	
	
	if (canEditService) {
 
	/* ---------- EDIT‑SERVICE LINK (membership‑aware) ---------------- */

(function buildEditServiceLink () {

  /* 1. Gather prices from metafields -------------------------- */
  const baseCost  = parseFloat(designObj.edit_service_cost ?? '0') || 0;
  const saleField = designObj.edit_service_sale;
  const saleCost  = (saleField !== '' && saleField !== null && !isNaN(+saleField))
                    ? parseFloat(saleField)
                    : NaN;                       // NaN = no explicit sale

  /* 2. Pick “starting” (non‑member) price --------------------- */
  const startingPrice = !Number.isNaN(saleCost) && saleCost >= 0
                        ? saleCost                 // explicit sale overrides base
                        : baseCost;

  /* 3. Apply membership discounts ----------------------------- */
  let effectiveCost = startingPrice;
  if (window.ultimatePlan) {
    effectiveCost = 0;                     // FREE for Ultimate
  } else if (window.proPlan) {
    effectiveCost = startingPrice * 0.50;  // 50 % off for Pro
  }

  /* 4. Prepare label text ------------------------------------- */
  const currency = (value) => `$${value.toFixed(2)}`;
  const isZero = (value) => Math.abs(value) < 0.0001;
  const hasSale = !Number.isNaN(saleCost) && saleCost >= 0 && saleCost < baseCost;

  let label;
  if (window.ultimatePlan) {
    label = 'Edit this for me (FREE with Ultimate)';
  } else if (window.proPlan) {
    label = isZero(effectiveCost)
      ? 'Edit this for me (FREE with Pro)'
      : `Edit this for me (${currency(effectiveCost)} with Pro)`;
  } else if (hasSale) {
    // non‑member but there’s an explicit sale
    label = isZero(saleCost)
      ? `Edit this for me (<s>${currency(baseCost)}</s> <b>FREE</b>)`
      : `Edit this for me (<s>${currency(baseCost)}</s> <b>${currency(saleCost)}</b>)`;
  } else if (isZero(baseCost)) {
    label = 'Edit this for me (FREE)';
  } else {
    label = `Edit this for me (${currency(baseCost)})`;
  }

  /* 5. Build URL – append membership flag for product page ---- */
  let esHref = buildUrlWithParams(productUrl, {
    from: 'templates',
    id: getDesignHandoffId(designObj),
    designnum: designObj.designnum || '',
    templateLookup: resolveTemplateLookupForDesign(designObj),
    artwork: 'editservice',
    editservice: 'true',
    bg_template_action: 'edit_service'
  });
  esHref = appendTargetingIDs(esHref, designObj);        // existing helper
  esHref = appendDesignPrintingParam(esHref, designObj);
  const selectedThumb = activeModal.querySelector('.backer-thumb.selected');
  let backerId = selectedThumb?.dataset?.backerId;
  if (!backerId && activeModal.dataset.selectedBacker) {
    backerId = activeModal.dataset.selectedBacker;
  }
  if (backerId) {
    esHref = buildUrlWithParams(esHref, { backer: backerId });
  }
  if (window.ultimatePlan)      esHref = buildUrlWithParams(esHref, { member: 'ultimate' });
  else if (window.proPlan)      esHref = buildUrlWithParams(esHref, { member: 'pro' });

  /* 6. Create/link DOM element ------------------------------- */
  const esLink = document.createElement('a');
  esLink.href        = esHref;
  esLink.className   = 'modal-editservice-button';
  esLink.innerHTML   = label;
  esLink.addEventListener('click', function(e) {
    if (!bgConfirmAiGeneratedEditServiceTemplate(designObj)) {
      e.preventDefault();
    }
  });

  // Replace any previous esLink (in case showDesign re‑renders)
  const prev = customizeContainer.querySelector('.modal-editservice-button');
  if (prev) prev.remove();
  customizeContainer.appendChild(esLink);
})();

		
	/* ===== Membership CTA ===== */
	if (window.__siteCfg?.memberships?.enabled !== false && !window.proPlan && !window.ultimatePlan) {

	  // compute potential savings for messaging ------------------
	  const baseCost = parseFloat(designObj.edit_service_cost   ?? '0') || 0;
	  const saleCost = parseFloat(designObj.edit_service_sale ?? baseCost) || baseCost;
	  const proCost  = (saleCost * 0.5).toFixed(2);   // 50 % off
	  const ultCost  = 0;                             // FREE

	  const cta = document.createElement('div');
	  cta.className = 'membership-cta';

	  cta.innerHTML = `
		<p style="margin:8px 0 4px;font-size:14px;">
		  Want <strong>FREE</strong> edit services?
		</p>
		<button class="bg-membership-cta-button">
		  Save with a Membership →
		</button>
	  `;
	  customizeContainer.appendChild(cta);

	  // ```open modal ------------------------------------------------
	  cta.querySelector('.bg-membership-cta-button').onclick = openMembershipModal;
	}
		
		

}

  if (canCustomizeOnline) {
    btn.textContent = 'Customize Online';
    customizeContainer.appendChild(btn);
  }
  if (legacyNote) {
    const note = document.createElement('div');
    note.className = 'legacy-template-note';
    note.textContent = legacyNote;
    customizeContainer.appendChild(note);
  }
}



  ///////////////////////////////////////////////////////////////////
  // 14) Finally, open the modal
  ///////////////////////////////////////////////////////////////////
  openModal(activeModal);
								  
	// --- 3D preview (inside showDesign) ---
	const previews = designObj.previews || [];
	const ps = designObj.preview_settings || {};
	const targetAR = getDesignAspectRatio(designObj);

	// Your logs: this is the right place
	//console.log('[3D] design', designObj.designnum, 'size=', designObj.size, 'AR=', targetAR);
	//console.log('[3D] container box =', imagesContainer.getBoundingClientRect());

	if (!isPlaceholder) {
	  requestAnimationFrame(() => {
		BG3DPreview.init(imagesContainer, previews, {
		  enable      : ps.enable_3d === true,
		  autoRotate  : ps.auto_rotate === true,
		  wobble      : ps.wobble === true,
		  rotateSpeed : ps.rotate_speed || 18,
		  finish      : ps.surface_finish || 'matte',
		  depth       : ps.depth_px ?? 2,
		  edgeColor   : ps.edge_color || '#fafafa',
		  initialAngle: ps.initial_angle || 0,
		  targetAR    : targetAR
		});
	  });
	} else {
	  // For placeholders, just show a flat image
	  imagesContainer.innerHTML =
		`<div class="bg-flat-preview"><img src="${previews[0] || ''}" alt=""></div>`;
	}
								  
								  
								  
								  
  if (!isPlaceholder && isDesktop) {
    setTimeout(() => {
      const twoImgs = imagesContainer.querySelectorAll('.image-container img');
      if (twoImgs.length === 2) {
        arrangeDesktopImagesAfterLoad(imagesContainer, [...twoImgs]);
      }
      makeImagesClickableForLightbox();
    },100);
  } else {
    makeImagesClickableForLightbox();
  }
}




  
function getDesignAspectRatio(d) {
  // Try explicit size (inches or feet)
  const raw = (d.size || '').trim().toLowerCase().replace(/\s+/g, '');
  // 12"x18", 12x18, 12in x 18in
  let m = raw.match(/^([\d.]+)(?:in|")?x([\d.]+)(?:in|")?$/i);
  if (!m) {
    // 2'x3'
    m = raw.match(/^([\d.]+)'x([\d.]+)'$/i);
    if (m) {
      const w = parseFloat(m[1]) * 12;
      const h = parseFloat(m[2]) * 12;
      if (w > 0 && h > 0) return w / h;
    }
  } else {
    const w = parseFloat(m[1]);
    const h = parseFloat(m[2]);
    if (w > 0 && h > 0) return w / h;
  }

  // Optionally look for a precomputed numeric field if you add one later:
  if (typeof d.preview_ar === 'number' && isFinite(d.preview_ar) && d.preview_ar > 0) {
    return d.preview_ar;
  }

  // Orientation hint as last-ditch default
  if (typeof d.orientation === 'string') {
    const o = d.orientation.toLowerCase();
    if (o.includes('landscape')) return 4 / 3;
    if (o.includes('portrait'))  return 3 / 4;
  }

  // No metadata; let the image probe decide
  return null;
}
	
	
	
	
	
	
	
////////////////////////////////////////////////////////////////////////
// B) BUILD A PRICE TABLE FROM base_partial_sku
////////////////////////////////////////////////////////////////////////
// OD-122 (owner answer "a", 2026-10-05; PR #634 fix round 3): a sale percent set
// on the product is not what checkout charges when no tier sale is behind it (a
// discountNN tag), so those rows show their price before discounts with the
// sentence under the table.
// SALE-DISPLAY-STRIKETHROUGH (owner, 2026-10-08): the store's tier sale (tierPct:
// the product's own custom.product_discount, not lead-product; the collection page
// passes it in window.productTierSalePercents) is Shopify's percentage discount,
// floor(unit cents x N / 100) off per Shopify unit (THEME-REL-7 R5), so each row
// shows its price crossed out and the price after that sale (156.46 at 15 percent
// is 133.00, never 132.99), the per piece rounded up to the cent.
function tierSaleLineCents(lineCents, pct, quantity) {
  var cents = Math.round(Number(lineCents));
  var rate = Math.round(Number(pct));
  var count = Math.max(1, Math.floor(Number(quantity) || 1));
  if (!Number.isSafeInteger(cents) || cents <= 0 || !(rate > 0) || rate >= 100) return cents;
  var unit = Math.floor(cents / count);
  var cut = unit * rate;
  return count * (unit - ((cut - (cut % 100)) / 100));
}

function readTierSalePercent(handle) {
  const value = Number(window.productTierSalePercents && window.productTierSalePercents[handle]);
  return Number.isInteger(value) && value > 0 && value < 100 ? value : 0;
}

// Fix round 1 (Astra P2 #6, review of #673): the badge beside the price table
// names the percent that owns the shown price pair, the store's tier sale
// (readTierSalePercent), never a discountNN tag, the legacy map or a member
// bonus. Without the tier sale the rows are before discounts with the
// sentence, so no sale badge shows; Unbeatable Price is not a discount and
// stays (the design page's rule, getShownDiscountBadgeText).
const UNBEATABLE_PRICE_BADGE = 'Unbeatable Price';

function buildShownSaleBadgeText(handle) {
  const tierPct = readTierSalePercent(handle);
  if (tierPct > 0) return `${tierPct}% Off Sale`;
  return hasUnbeatablePriceTag(handle) ? UNBEATABLE_PRICE_BADGE : '';
}

function renderReferencePriceTable(container, designObj, discountPct, tierPct) {
  const reader = window.BGReferencePricing;
  const token = {};
  container.__bgReferencePriceToken = token;
  function render() {
    if (container.__bgReferencePriceToken !== token) return;
    container.innerHTML = buildLivePriceTable(designObj, discountPct, tierPct);
    const disclaimer = String(designObj.pricing_disclaimer || '').trim();
    if (disclaimer) {
      const node = document.createElement('p');
      node.className = 'pricing-disclaimer';
      node.textContent = disclaimer;
      node.style.marginBottom = '10px';
      container.insertAdjacentElement('afterbegin', node);
    }
  }
  render();
  if (reader) reader.load({ storeKey: window.BGDesignsCollectionConfig && window.BGDesignsCollectionConfig.brandSlug, productHandle: reader.handle(designObj) }).then(function (entry) {
    return entry.status === 'legacy' ? legacyReferencePricingPromise : null;
  }).then(render);
}

function buildLivePriceTable(designObj, discountPct = 0, tierPct = 0) {
  const reader = window.BGReferencePricing;
  if (!reader) return '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
  if (reader.linksElsewhere(designObj)) return reader.unavailableHtml;
  const entry = reader.peek({ storeKey: window.BGDesignsCollectionConfig && window.BGDesignsCollectionConfig.brandSlug, productHandle: reader.handle(designObj) });
  if (entry && entry.status === 'admin') return reader.tableHtml(entry, Object.assign({}, designObj, { Printing_targetingID: getDesignPrintingTargetingID(designObj) || designObj.Printing_targetingID }), discountPct);
  if (!entry || entry.status !== 'legacy') return reader.unavailableHtml;
  // 1) If no base_partial_sku => show a quick message
  if (!designObj.base_partial_sku) {
    return `<p class="no-pricing">No pricing data available.</p>`;
  }

  const partialSku = designObj.base_partial_sku.trim();
  if (!partialSku) {
    return `<p class="no-pricing">Pricing will be confirmed on the product page.</p>`;
  }

  // 2) Gather all matching SKUs => e.g. "222-34-28-q###"
  let matchedSKUs = [];
  const allPricing = window.MasterPricingData?.pricing || {};

  for (let skuKey in allPricing) {
    if (skuKey.startsWith(partialSku + '-q')) {
      matchedSKUs.push(skuKey);
    }
  }
  // Sort them by ascending quantity
  matchedSKUs.sort((a, b) => {
    let qA = extractQty(a); 
    let qB = extractQty(b);
    return qA - qB;
  });

  if (!matchedSKUs.length) {
    return `<p class="no-pricing">Pricing will be confirmed on the product page.</p>`;
  }

  // 3) Build the table
  let html = `
    <table class="price-table">
      <thead>
        <tr>
          <th>Quantity</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
  `;
  for (let sku of matchedSKUs) {
    let priceObj = allPricing[sku] || {};
    let totalPrice = exactRowAmount(parseFloat(priceObj.price || 0));
    let qty = extractQty(sku);
    let costEach = (qty > 0) ? (totalPrice / qty) : 0;
    const totalCents = Math.round(totalPrice * 100);
    const saleCents = tierPct > 0 ? tierSaleLineCents(totalCents, tierPct, 1) : totalCents;

    if (saleCents < totalCents) {
      const saleEach = qty > 0 ? Math.ceil(saleCents / qty - 1e-7) / 100 : saleCents / 100;
      html += `
      <tr>
        <td>${qty}</td>
        <td>
          <s>$${totalPrice.toFixed(2)}</s>
          <span class="bg-dc-sale-price">$${(saleCents / 100).toFixed(2)}</span>
          &nbsp;<em>($${saleEach.toFixed(2)}/ea)</em>
        </td>
      </tr>
    `;
      continue;
    }
    html += `
      <tr>
        <td>${qty}</td>
        <td>
          $${totalPrice.toFixed(2)}
          &nbsp;<em>($${costEach.toFixed(2)}/ea)</em>
        </td>
      </tr>
    `;
  }
  html += `</tbody></table>`;
  if (discountPct > 0 && !(tierPct > 0)) {
    html += `<p class="bg-dc-sale-pending-note" role="status" style="margin:8px 0 0;font-size:12px;line-height:1.5;opacity:.8;">Price before discounts. Final discounts are calculated at checkout.</p>`;
  }
  return html;
}

/** Helper: parse the final "q####" from SKU */
// EXACT-CENTS-CATALOG (2026-10-03): a price row as authored, shown in the cents the
// product page and the cart charge (the quote engine's half-up cent: toFixed showed a
// 135.795 row as 135.79). A positive price row only.
function exactRowAmount(value) {
  var micros = Math.round(Number(value) * 1000000);
  return Number.isFinite(micros) ? Math.round(micros / 10000) / 100 : value;
}

function extractQty(skuStr) {
  // e.g. "222-34-28-q500" => extract "500"
  let parts = skuStr.split('-q');
  if (parts.length < 2) return 0;
  let qNum = parseInt(parts[1], 10);
  return isNaN(qNum) ? 0 : qNum;
}

	
	
	
	
	

  function openModal(modal){
    document.body.classList.add('modal-open');
    modal.style.display='block';
  }
  function closeModal(modal){
  modal.style.display = 'none';
  document.body.classList.remove('modal-open');
  modal.dispatchEvent(new CustomEvent('modal:close')); 
}

  /* =============== 7) PAGINATION =============== */
  function updatePaginationControls(numPages) {
    const pc=document.getElementById('pagination-controls');
    pc.innerHTML='';
    const prev=document.createElement('button');
    prev.className='previousButton';
    prev.innerHTML='<svg viewBox="0 0 24 24" style="transform: scaleX(-1);"><path d="M9 6l6 6-6 6"/></svg>';
    prev.onclick=()=>changePage(currentPage-1);
    if(currentPage===1) prev.disabled=true;
    pc.appendChild(prev);

    for(let i=1;i<=numPages;i++){
      const btn=document.createElement('button');
      btn.textContent=i;
      btn.className=(i===currentPage?'active ':'')+'pageNumber';
      btn.onclick=()=>changePage(i);
      pc.appendChild(btn);
    }

    const next=document.createElement('button');
    next.className='nextButton';
    next.innerHTML='<svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>';
    next.onclick=()=>changePage(currentPage+1);
    if(currentPage===numPages) next.disabled=true;
    pc.appendChild(next);
  }

  function changePage(pageNum) {
    const f=getFilteredDesigns();
    const numPages=Math.ceil(f.length/itemsPerPage);
    currentPage=pageNum;
    window.currentPage=currentPage;
    renderDesigns(f);
    updatePaginationControls(numPages);
    scrollToolbar();
  }

  /* =============== 8) SELECTED FILTERS + RESULTS =============== */
  function updateResultsCount() {
    const f = getFilteredDesigns();
    document.querySelector('.results-count').textContent=`${f.length} results`;
  }

  function updateSelectedFilters() {
    const container = document.querySelector('.selected-filters');
    container.innerHTML='';
    const sel={};
    filterFields.forEach(ff => sel[ff.field]=getSelectedValues(ff.id));
    const sVal=searchInput.value.trim();
    const terms=sVal?[sVal]:[];
    const allSel=[].concat(...Object.values(sel),...terms);

    allSel.forEach(as=>{
      const span=document.createElement('span');
      span.textContent=as;
      const btn=document.createElement('button');
      btn.textContent='x';
      btn.onclick=(e)=>{
        e.stopPropagation();
        removeFilter(as);
      };
      span.appendChild(btn);
      container.appendChild(span);
    });
    if(allSel.length){
      const clearAllBtn=document.createElement('button');
      clearAllBtn.classList.add('clear-all-button');
      clearAllBtn.textContent='Clear All';
      clearAllBtn.onclick=resetFilters;
      container.appendChild(clearAllBtn);
    }
  }
  window.updateSelectedFilters=updateSelectedFilters;

  function removeFilter(val) {
    const low=val.toLowerCase();
    const sVal=searchInput.value.toLowerCase().trim();
    if(sVal===low){
      searchInput.value='';
      clearSearchButton.style.display='none';
      hideSearchSuggestions();
      filterDesigns();
    } else {
      const cbs=document.querySelectorAll('.checkbox-group input[type="checkbox"]');
      cbs.forEach(cb=>{
        if(cb.value.toLowerCase()===low){
          cb.checked=false;
        }
      });
      filterDesigns();
    }
  }

  function resetFilters() {
    document.querySelectorAll('.checkbox-group input[type="checkbox"]').forEach(cb=>cb.checked=false);
    bgClearSwatchSelection();
    searchInput.value='';
    clearSearchButton.style.display='none';
    hideSearchSuggestions();
    filterDesigns();
  }

  function clearSearch() {
    searchInput.value='';
    clearSearchButton.style.display='none';
    searchInput.focus();
    hideSearchSuggestions();
    filterDesigns();
  }

  function handleResize(){
    const w=window.innerWidth;
    const cols=w<=575?2:(w<=767?3:4);
    setGridButtonActive(cols);
  }
  function setGridButtonActive(cols){
    gridOptionBtns.forEach(b=>{
      b.classList.remove('active');
      if(b.getAttribute('data-toggle-grid')==cols){
        b.classList.add('active');
        document.getElementById('design-grid').className=`grid--${cols}-col-desktop grid`;
      }
    });
  }

  /* =============== 9) HELPER FUNCTIONS =============== */
  function levenshteinDistance(a,b){
    const matrix=[];
    for(let i=0;i<=b.length;i++) matrix[i]=[i];
    for(let j=0;j<=a.length;j++) matrix[0][j]=j;
    for(let i=1;i<=b.length;i++){
      for(let j=1;j<=a.length;j++){
        if(b.charAt(i-1)===a.charAt(j-1)){
          matrix[i][j]=matrix[i-1][j-1];
        } else {
          matrix[i][j]=Math.min(
            matrix[i-1][j-1]+1,
            matrix[i][j-1]+1,
            matrix[i-1][j]+1
          );
        }
      }
    }
    return matrix[b.length][a.length];
  }

  function generateNGrams(str,n=3){
    const set=new Set();
    const len = str.length;
    if (!len) return set;
    const size = Math.min(n, len);
    for(let i=0;i<=len-size;i++){
      set.add(str.slice(i,i+size));
    }
    return set;
  }

  function debounce(fn, ms){
    let timeout;
    return (...args)=>{
      clearTimeout(timeout);
      timeout=setTimeout(()=>fn.apply(this,args), ms);
    };
  }

  /* =============== 10) SHOW MORE BUTTONS =============== */
  function setupShowMoreButtons(){
    document.querySelectorAll('.filter-group').forEach(group=>{
      const checkboxes=Array.from(group.querySelectorAll('.checkbox-group label'));
      let showMoreButton=group.querySelector('.show-more');
      if(!showMoreButton) return;
      const isExpanded=group.classList.contains('expanded');
      const newBtn=showMoreButton.cloneNode(true);
      showMoreButton.parentNode.replaceChild(newBtn, showMoreButton);
      showMoreButton=newBtn;

      if(checkboxes.length>9){
        checkboxes.forEach((cb,idx)=>{
          if(!isExpanded && idx>=9){
            cb.classList.add('hidden');
          } else {
            cb.classList.remove('hidden');
          }
        });
        showMoreButton.classList.add('visible');
      } else {
        checkboxes.forEach(cb=>cb.classList.remove('hidden'));
        showMoreButton.classList.remove('visible');
      }
      showMoreButton.textContent=isExpanded?'- LESS':'+ MORE';
      showMoreButton.addEventListener('click',function(){
        const nowExpanded=group.classList.toggle('expanded');
        if(nowExpanded){
          checkboxes.forEach(cb=>cb.classList.remove('hidden'));
          showMoreButton.textContent='- LESS';
        } else {
          checkboxes.forEach((cb,i)=>{
            if(i>=9)cb.classList.add('hidden');
          });
          showMoreButton.textContent='+ MORE';
        }
      });
    });
  }

	
	
function applyFiltersFromURL() {
  const url = new URL(window.location.href);
  const qp  = url.searchParams;


  const PARAM_SYNONYMS = new Map([
    ['product','product'],
    ['category','category'],
    ['industry','industry'],
    ['shape','shape'],
    ['size','size'],
    ['sign style','style'],   // legacy
    ['signstyle','style'],    // legacy
    ['style','style'],
    ['styles','style'],
    ['styles themes','styles_themes'],
    ['stylesthemes','styles_themes'],

    ['print colors','print_colors'],
    ['printcolors','print_colors'],
    ['editability','editability'],
    ['orientation','orientation'],
    ['color','color'],
    ['corners','corners'],
    ['material','material'],
    ['equipment','equipment'],
    ['type','type'],
    ['fold','fold'],
    ['perforation','perforation'],
    ['use case','use_case'],
    ['usecase','use_case'],
    ['direct mail','direct_mail'],
    ['directmail','direct_mail'],

    ['q','q'],
    ['query','q'],
    ['search','q'],

    ['sort','_sort'],
    ['Sort','_sort'],
    ['Sort By','_sort'],
  ]);

  const canonKey = k => (k || '').toString().trim().toLowerCase().replace(/[_-]+/g, ' ');
  const splitMulti = v => {
    // allow comma, pipe, repeated params; trim & drop empties
    if (!v) return [];
    return v.split(/[|,]/).map(s => s.trim()).filter(Boolean);
  };
  const normQuotes = s => (s || '')
    .replace(/[“”]/g, '"')
    .replace(/[’]/g, "'")
    .replace(/(\d+(?:\.\d+)?)(\"|')?\s*[\u00D7x]\s*(\d+(?:\.\d+)?)(\"|')?/gi, '$1$2 x $3$4')
    .replace(/\s+/g, ' ')
    .trim();

  // Collect canonical params -> array of values
  const incoming = {};
  for (const [rawKey, rawVal] of qp.entries()) {
    const k = PARAM_SYNONYMS.get(canonKey(rawKey)) || null;
    if (!k) continue;
    const normalizedVal = normQuotes(rawVal);
    const values = k === 'q'
      ? (normalizedVal ? [normalizedVal] : [])
      : splitMulti(normalizedVal);
    if (!values.length) continue;
    if (!incoming[k]) incoming[k] = [];
    incoming[k].push(...values);
  }

  if (incoming.q && incoming.q.length && searchInput) {
    const qVal = incoming.q[0];
    searchInput.value = qVal;
    clearSearchButton.style.display = qVal ? 'block' : 'none';
  }

  // Helper to (case-insensitively) check a checkbox set
  const checkMatching = (selector, wantedValues) => {
    if (!wantedValues || !wantedValues.length) return 0;
    const cbs = Array.from(document.querySelectorAll(selector));
    let applied = 0;

    // make a fast lookup of wanted values (lowercased)
    const wantSet = new Set(wantedValues.map(v => v.toLowerCase()));
    cbs.forEach(cb => {
      const v = (cb.value || '').toLowerCase();
      if (wantSet.has(v)) {
        cb.checked = true;
        applied++;
      }
    });
    return applied;
  };

  const mapSizeParamsToDisplay = (values) => {
    const out = [];
    const data = window.filterSourceData || [];
    const byRaw = new Map();
    data.forEach(d => {
      const raw = normQuotes(d && d.size);
      if (!raw) return;
      const display = getSizeDisplayValue(d);
      if (display) byRaw.set(raw.toLowerCase(), display);
    });
    values.forEach(val => {
      const v = normQuotes(val);
      if (!v) return;
      out.push(v);
      const mapped = byRaw.get(v.toLowerCase());
      if (mapped) out.push(mapped);
    });
    return out;
  };

  // Special: for size we also try orientation-swapped variants.
  const expandSizeValues = (values) => {
    const out = new Set();
    values.forEach(val => {
      const v = normQuotes(val);
      out.add(v); // original

      // detect WxH in inches/feet; create reversed version
      const mIn = v.match(/^(\d*\.?\d+)"?\s*x\s*(\d*\.?\d+)"?$/i);
      const mFt = v.match(/^(\d*\.?\d+)'?\s*x\s*(\d*\.?\d+)'?$/i);
      if (mIn) {
        const a = parseFloat(mIn[1]), b = parseFloat(mIn[2]);
        if (isFinite(a) && isFinite(b) && a !== b) {
          out.add(`${mIn[2]}" x ${mIn[1]}"`);
        }
      } else if (mFt) {
        const a = parseFloat(mFt[1]), b = parseFloat(mFt[2]);
        if (isFinite(a) && isFinite(b) && a !== b) {
          out.add(`${mFt[2]}' x ${mFt[1]}'`);
        }
      }
    });
    return Array.from(out);
  };

  // ------------- Pre-select checkboxes from URL -------------
  let anyApplied = 0;
  Object.entries(incoming).forEach(([k, vals]) => {
    // sort is handled by applyInitialSortFromMeta(), but keep reading for completeness
    if (k === '_sort' || k === 'q') return;
    // product is swatch-backed and applied below, not via checkboxes
    if (k === 'product') return;

    const id = `#${k}-filter input[type="checkbox"]`;
    let toUse = vals.slice();

    if (k === 'size') {
      const mapped = mapSizeParamsToDisplay(toUse);
      toUse = expandSizeValues(mapped);
    }

    // match by value (DOM property resolves &quot; to actual ")
    const applied = checkMatching(id, toUse);
    if (applied === 0) {
      console.log('[URLSync] No matches for', k, 'with', toUse);
    } else {
      console.log('[URLSync] Applied', applied, 'checkbox(es) for', k, toUse);
      anyApplied += applied;
    }
  });

  // Product selection is swatch-backed (no checkbox group to pre-check).
  if (incoming.product && incoming.product.length) {
    bgApplySwatchSelectionFromValues(incoming.product);
  }

  // If nothing matched, we still respect ?sort= via your existing code.
  // After preselection, trigger filter pipeline once.
  filterDesigns();

  // Done reading initial params—turn URL syncing on
  __suppressURLSync = false;

  // Handle sorting synonyms too (your applyInitialSortFromMeta already runs pre‑render,
  // but this gives us resilience if the order of calls ever changes.)
  if (incoming._sort && incoming._sort.length) {
    const raw = (incoming._sort[0] || '').toLowerCase();
    const map = { 'new':'newest', 'new release':'newest', 'popular':'most_popular', 'random':'random', 'default':'default', 'newest':'newest', 'most_popular':'most_popular' };
    const sel = document.getElementById('sort-select');
    const target = map[raw] || 'default';
    if (sel && sel.value !== target) {
      sel.value = target;
      filterDesigns();
    }
  }
}

	
	
function setupSortButtons() {
  const randomBtn  = document.getElementById('sort-btn-random');
  const newestBtn  = document.getElementById('sort-btn-new');
  const popularBtn = document.getElementById('sort-btn-popular');
  const sortSelect = document.getElementById('sort-select');

  randomBtn.addEventListener('click', () => {
    sortSelect.value = 'random';
    filterDesigns();       // triggers re-render
    syncSortButtons('random');
  });
  newestBtn.addEventListener('click', () => {
    sortSelect.value = 'newest';
    filterDesigns();
    syncSortButtons('newest');
  });
  popularBtn.addEventListener('click', () => {
    sortSelect.value = 'most_popular';
    filterDesigns();
    syncSortButtons('most_popular');
  });

  // Listen for changes in the <select> 
  sortSelect.addEventListener('change', () => {
    syncSortButtons(sortSelect.value);
  });

  // Initialize highlight
  syncSortButtons(sortSelect.value);

  function syncSortButtons(mode) {
    // Remove "active" from all
    randomBtn.classList.remove('active');
    newestBtn.classList.remove('active');
    popularBtn.classList.remove('active');

    // Add "active" to whichever mode is current
    if (mode === 'random') {
      randomBtn.classList.add('active');
    } else if (mode === 'newest') {
      newestBtn.classList.add('active');
    } else if (mode === 'most_popular') {
      popularBtn.classList.add('active');
    }
  }
}
	
	
function installCopyLinkButton() {
  const host = document.getElementById('sort-buttons-share-row')
            || document.getElementById('sort-buttons')
            || document.querySelector('.selected-filters-container')
            || document.querySelector('.toolbar');
  if (!host) {
    console.warn('[ShareLink] No host found for copy button');
    return;
  }
  if (document.getElementById('copy-share-link')) return; // idempotent

  const btn = document.createElement('button');
  btn.id = 'copy-share-link';
  btn.type = 'button';
  btn.className = 'copy-link-btn';
  btn.setAttribute('aria-label','Copy shareable link');
  btn.innerHTML = `<span aria-hidden="true">🔗</span> Copy link`;

  btn.addEventListener('click', async () => {
    try {
      if (typeof __suppressURLSync !== 'undefined' && __suppressURLSync) {
        console.log('[ShareLink] Forcing URL sync before copy');
        if (typeof syncURLWithState === 'function') {
          syncURLWithState();
        }
      }
      btn.disabled = true;
      const href = window.location.href;
      await copyTextToClipboard(href);
      showToast('Link copied!');
      console.log('[ShareLink] Copied:', href);
    } catch (err) {
      console.error('[ShareLink] Copy failed', err);
      showToast('Could not copy link', 'error');
    } finally {
      btn.disabled = false;
    }
  });

  host.appendChild(btn);
}

async function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }
  return new Promise((resolve, reject) => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly','');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error('execCommand failed'));
    } catch (e) {
      reject(e);
    }
  });
}

function showToast(message, type='info') {
  let toast = document.getElementById('bg-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'bg-toast';
    toast.className = 'bg-toast';
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.style.background = (type === 'error') ? '#b42318' : '#33373B';

  requestAnimationFrame(() => {
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2200);
  });
}

function installShareButton() {
  const isMobile = matchMedia('(max-width: 767px)').matches || /Mobi|Android/i.test(navigator.userAgent);
  if (!('share' in navigator) || !isMobile) return;

  const host = document.getElementById('sort-buttons-share-row')
            || document.getElementById('sort-buttons')
            || document.querySelector('.selected-filters-container')
            || document.querySelector('.toolbar');
  if (!host) return;
  if (document.getElementById('web-share-btn')) return; // idempotent

  const btn = document.createElement('button');
  btn.id = 'web-share-btn';
  btn.type = 'button';
  btn.className = 'copy-link-btn';        // reuse the same styling
  btn.setAttribute('aria-label','Share this filtered view');
  btn.innerHTML = `<span aria-hidden="true">📤</span> Share…`;

  btn.addEventListener('click', async () => {
    try {
      // Ensure URL reflects current state before sharing
      if (typeof __suppressURLSync !== 'undefined' && __suppressURLSync && typeof syncURLWithState === 'function') {
        syncURLWithState();
      }
      const url   = window.location.href;
      const title = (document.querySelector('.main-page-title')?.textContent || document.title).trim();
      const text  = 'Check out these prefiltered templates';

      const data = { title, text, url };
      if (navigator.canShare && !navigator.canShare(data)) {
        await copyTextToClipboard(url);
        showToast('Link copied');
        return;
      }
      await navigator.share(data);
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      try {
        await copyTextToClipboard(window.location.href);
        showToast('Link copied');
      } catch {
        showToast('Sharing not available', 'error');
      }
    }
  });

  host.appendChild(btn);
}

	
setupSortButtons();
installCopyLinkButton();
installShareButton(); 
attachHeroCtaHandlers();
	
	
	
});
	

(function () {

  /* helper: 16Ã¢â‚¬Â¯Ãƒâ€”Ã¢â‚¬Â¯16 chevron (mirrored if needed) */
  function arrowSVG(mirror) {
    const path = '<path d="M4 0l6 6-6 6"/>';
    return `<svg aria-hidden="true" focusable="false" viewBox="0 0 12 12"
            style="${mirror ? 'transform:scaleX(-1);':''}">${path}</svg>`;
  }

  /* ----------------------------------------------------------------
     Flat (non-3D) preview.
     When the design has a distinct second preview we still owe the
     shopper a way to see the back, so render Front/Back controls that
     swap the image in place.
  -----------------------------------------------------------------*/
  function renderFlatPreview(mount, imgs, opt) {
    if (!mount) return;

    const list  = Array.isArray(imgs) ? imgs.filter(Boolean) : [];
    const front = list[0] || '';
    const back  = list[1] || '';

    if (!back || back === front) {
      mount.innerHTML = `<div class="bg-flat-preview"><img src="${front}" alt="" loading="lazy"></div>`;
      return;
    }

    // A caller that asked to open on the back (e.g. a chosen backer) passes
    // initialAngle 180; honour that here the same way the cube does.
    const angle = Number(opt && opt.initialAngle);
    const norm  = isFinite(angle) ? (((angle % 360) + 360) % 360) : 0;
    const startOnBack = norm > 90 && norm < 270;

    mount.innerHTML = `
      <div class="bg-flat-preview bg-flat-preview--faces">
        <div class="bg-flat-preview__stage">
          <img src="${startOnBack ? back : front}" alt="" loading="lazy">
        </div>
        <div class="bg-flat-preview__controls" role="group" aria-label="Preview side">
          <button type="button" class="bg-3d-preview__fb${startOnBack ? '' : ' is-active'}"
                  data-face="front" aria-pressed="${startOnBack ? 'false' : 'true'}">Front</button>
          <button type="button" class="bg-3d-preview__fb${startOnBack ? ' is-active' : ''}"
                  data-face="back" aria-pressed="${startOnBack ? 'true' : 'false'}">Back</button>
        </div>
      </div>`;

    // Warm the off-screen side so the first toggle does not flash.
    const warm = new Image();
    warm.src = startOnBack ? front : back;

    const img  = mount.querySelector('.bg-flat-preview__stage img');
    const btns = [...mount.querySelectorAll('.bg-flat-preview__controls .bg-3d-preview__fb')];
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        img.src = btn.dataset.face === 'back' ? back : front;
        btns.forEach(b => {
          const active = (b === btn);
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  /* ----------------------------------------------------------------
     PUBLIC API
  -----------------------------------------------------------------*/
window.BG3DPreview = {
  init(mount, imgs, opt = {}) {
    opt = Object.assign({
      enable       : false,
      autoRotate   : false,
      wobble       : false,
      rotateSpeed  : 18,
      depth        : 2,
      edgeColor    : '#fafafa',
      finish       : 'glossy',
      initialAngle : 0,
      targetAR     : null   // NEW
    }, opt);

    // flat fallback — still exposes Front/Back when a back preview exists
    if (!mount || !imgs?.length || !opt.enable) {
      renderFlatPreview(mount, imgs, opt);
      return;
    }

    const metadataAR = (typeof opt.targetAR === 'number' && isFinite(opt.targetAR) && opt.targetAR > 0)
	  ? opt.targetAR : null;

    const fallbackBoxAR = () => {
      const r = mount.getBoundingClientRect();
      return Math.max(0.1, (r.width || 1) / (r.height || 1));
    };

    const resolveAR = (imgAR) => {
      if (typeof imgAR === 'number' && isFinite(imgAR) && imgAR > 0) return imgAR;
      if (metadataAR) return metadataAR;
      return fallbackBoxAR();
    };

    const probe = new Image();
    probe.onload = () => {
      const imgAR = (probe.naturalWidth && probe.naturalHeight)
        ? (probe.naturalWidth / probe.naturalHeight)
        : null;
      buildCube(resolveAR(imgAR));
    };
    probe.onerror = () => {
      console.warn('[3D] probe failed; using mount box AR as fallback');
      buildCube(resolveAR(null));
    };
    probe.src = imgs[0];



      /* ---------- main builder -------------------------------- */
      function buildCube(ar) {
        mount.innerHTML = '';

        /* wrapper & css vars ----------------------------------- */
        const wrap = document.createElement('div');
        wrap.className = 'bg-3d-preview';
        wrap.style.setProperty('--cube-ar',   ar.toFixed(6));
        wrap.style.setProperty('--cube-depth', opt.depth + 'px');
        wrap.style.setProperty('--cube-edge',  opt.edgeColor);
        mount.appendChild(wrap);

        /* DOM skeleton ----------------------------------------- */
        wrap.innerHTML = `
          <div class="bg-3d-preview__scene ${opt.finish}"></div>
          <div class="bg-3d-preview__controls">
            <button class="bg-3d-preview__fb" data-face="front">Front</button>
            <button class="bg-3d-preview__fb" data-face="back">Back</button>
          </div>`;

        const scene = wrap.querySelector('.bg-3d-preview__scene');
	
		scene.style.height      = '100%';   // fill wrapper
		scene.style.paddingTop  = '0';      // kill aspectÃ¢â‚¬â€˜ratio padding
		scene.style.maxHeight   = '100%';   // safety

        scene.innerHTML = `
            <div class="bg-3d-preview__face front  ${opt.finish}"></div>
            <div class="bg-3d-preview__face back   ${opt.finish}"></div>
            <div class="bg-3d-preview__edge left"></div>
            <div class="bg-3d-preview__edge right"></div>
            <div class="bg-3d-preview__edge top"></div>
            <div class="bg-3d-preview__edge bottom"></div>`;

        scene.querySelector('.front').style.backgroundImage =
            `url('${imgs[0]}')`;
        scene.querySelector('.back' ).style.backgroundImage =
            `url('${imgs[1] || imgs[0]}')`;

        /* ---------- state -------------------------------------- */
        let angleY   = opt.initialAngle;   // yaw
        let angleX   = 0;                  // pitch
        let spinning = !!opt.autoRotate;
        let wobbling = !!opt.wobble && !spinning;
        let rafId    = null;
        let lastTs   = null;
		  
		  
		  
		        function applyTransform () {
        scene.style.transform =
          `rotateX(${angleX}deg) rotateY(${angleY}deg)`;

        /* moving shine (good for glossy / semi)``` */
        const p = (((angleY % 360)+360)%360) / 360 * 100;
        scene.style.setProperty('--shine', p.toFixed(1) + '%');
      }

      function stopMotion () {
        spinning = wobbling = false;
        scene.classList.remove('autospin', 'wobble');
      }


/* ------------ size limiter (desktop & mobile) ---------------- */
/* ------------ size limiter (desktop & mobile) ---------------- */
function fitToViewport () {
  // If the element is hidden, try again next frame when it’s likely visible
  const hidden = (mount.offsetParent === null) || getComputedStyle(mount).display === 'none';
  if (hidden) {
    requestAnimationFrame(fitToViewport);
    return;
  }

  const isMobile = matchMedia('(max-width:767px)').matches;
  const box = mount.getBoundingClientRect();
  const parentW = box.width  || window.innerWidth;
  const parentH = box.height || window.innerHeight;

  if (isMobile) {
    const maxW = parentW * 0.92;
    const maxH = parentH * 0.92;
    let w = maxW, h = w / ar;
    if (h > maxH) { h = maxH; w = h * ar; }
    wrap.style.width = w + 'px';
    wrap.style.maxWidth = w + 'px';
    wrap.style.height = h + 'px';
    wrap.style.maxHeight = h + 'px';
  } else {
    const heightCap = Math.min(parentH * 0.92, window.innerHeight * 0.80, 600);
    let h = Math.min(heightCap, parentH * 0.92);
    let w = Math.min(parentW * 0.92, h * ar);
    h = w / ar;
    wrap.style.width = w + 'px';
    wrap.style.maxWidth = w + 'px';
    wrap.style.height = h + 'px';
    wrap.style.maxHeight = h + 'px';
  }
}




      fitToViewport();
      window.addEventListener('resize', fitToViewport);

        /* ---------- transform & shine updater ------------------ */
      const degPerMs = 360 / (opt.rotateSpeed * 1000);
      function loop (ts) {
        if (spinning && lastTs) {
          angleY += (ts - lastTs) * degPerMs;
          applyTransform();
        }
        lastTs = ts;
        rafId  = requestAnimationFrame(loop);
      }
      rafId = requestAnimationFrame(loop);
      if (wobbling) scene.classList.add('wobble');
      applyTransform();





        /* smooth flip to 0Ã‚Â° or 180Ã‚Â° ---------------------------- */
        const flipTo = (targetDeg) => {
          stopMotion();
          const diff =
            ((targetDeg - angleY + 540) % 360) - 180; // shortest path
          const start = angleY;
          const dur   = 400;            // ms
          const t0    = performance.now();
          const ease  = t => t < .5 ? 2*t*t : -1 + (4-2*t)*t;

          const anim = (now) => {
            const p = Math.min(1, (now - t0) / dur);
            angleY  = start + diff * ease(p);
            applyTransform();
            if (p < 1) requestAnimationFrame(anim);
          };
          requestAnimationFrame(anim);
        };

        /* ---------- front / back buttons ----------------------- */
        wrap.querySelectorAll('.bg-3d-preview__fb').forEach(btn => {
          btn.addEventListener('click', () => {
            flipTo(btn.dataset.face === 'front' ? 0 : 180);
          });
        });

        /* ---------- pointerÃ¢â‚¬â€˜drag (yaw + pitch) ----------------- */
      let dragging = false, sx=0, sy=0, syaw=0, spitch=0;
      const onDown = e => { dragging=true; stopMotion();
                            sx=e.clientX; sy=e.clientY;
                            syaw=angleY; spitch=angleX; };
      const onMove = e => {
        if(!dragging) return;
        const dx = e.clientX - sx;
        const dy = e.clientY - sy;
        angleY = syaw + dx;
        angleX = Math.max(-30, Math.min(30, spitch - dy*0.3));
        applyTransform();
      };
      const endDrag = () => { dragging=false; };

      scene.addEventListener('pointerdown',  onDown);
      window.addEventListener('pointermove',  onMove);
      window.addEventListener('pointerup',    endDrag);
      window.addEventListener('pointercancel', endDrag);

      /* ------------ cleanÃ¢â‚¬â€˜up when modal closes --------------- */
      wrap.closest('.bg-custom-modal')
          ?.addEventListener('modal:close', () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener('resize', fitToViewport);
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup',   endDrag);
            window.removeEventListener('pointercancel', endDrag);
            });
      } // buildCube
    } // init
  }; // window.BG3DPreview

})();   /*  end IIFE  */
